import { Directive, Input, Output, Component, EventEmitter, OnInit, HostListener, ElementRef, ViewChild, NgZone } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
// import { SweetAlertService } from 'ngx-sweetalert2';
import swal from 'sweetalert2/dist/sweetalert2.js'
import *as $ from 'jquery';
// import { SweetAlertService } from 'ngx-sweetalert2';
// import { NotificationsService } from 'angular2-notifications';
// import * as countries from '../../assets/json/countries.json';
// import { countries_json } from './countries.json';

// import { MyService } from "./my-service.ts";
// import { MyCurrencyFormatterDirective } from "my-currency-formatter";

// import {IMyDpOptions} from 'mydatepicker';
const countries = require('./countries.json');


declare function require(arg: string): any;

@Component({
	selector: 'mbx-esscalo',
	templateUrl: './escalo.template.html',
	styleUrls: ['./escalo.css', '../styles/mbx-custom.css', '../styles/esscalo.css'],
	providers: [FormBuilder, NotificationsService, swal],
})

export class EsscaloComponent implements OnInit {

	// @ViewChild('deleteSwal') private deleteSwal: SwalComponent;
	// public onBeforeOpen(event: BeforeOpenEvent): void {
	//   // You can access the modal's native DOM node:
	//   console.log(event.modalElement);
	// }

	private countries_data: any = countries;
	private _contractors_data: any;
	private _quotes_data: any;
	private _pag_config: any;
	private totalPages: any;
	private pages_: any;
	private resChangeStatus: any;
	private _insuredList: any;
	private _containers_list: any;
	private _coverages_list: any;
	private _commodity_list: any = [];
	private data_services: any;

	private _notifications: NotificationsService
	public bsValue: any = '';

	loader = require('../../assets/images/loader/black_loader.gif');
	loader_yellow = require('../../assets/images/loader/loading-yellow.gif');
  	file_selected = {};
	document_file;

	startMinDate: Date;
	startMaxDate: Date;

	endMinDate: Date;
	endMaxDate: Date;

	bsConfigStart = {
		dateInputFormat: 'DD/MM/YYYY',
		dateOutputFormat: 'DD/MM/YYYY',
		containerClass: 'theme-dark-blue',
		showWeekNumbers: false,
		initialDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1)
	};

	bsConfigEnd = {
		dateInputFormat: 'DD/MM/YYYY',
		dateOutputFormat: 'DD/MM/YYYY',
		containerClass: 'theme-dark-blue',
		showWeekNumbers: false
	};

	fechaInicioValido: boolean = true;
	fechaFinValido: boolean = true;

	tarifas_mercancias = [];
	limite_despacho = 0;
	leyenda_seguridad = "";
	rate_exchange = [];
	rate_exchange_mxn = 0;
	rate_exchange_usd = 0;
	rate_exchange_eur = 0;
	id_company = 1;
	reference = false;
	clear_form = false;
	reference_transport = false;
	flag_ = true;
	valor_mecancia;
	valor_flete;
	valor_impuestos;
	valor_operacion;
	free_container = false;
	free = [
		{ 'serie': null }
	];
	currency_select = 1;
	showModalContainer = false;
	value_disabled = false;
	fecha = new Date();
	coberage_full = false;
	success_certificate_id;
	success_certificate = [];
	user_ = [{
		'email': '',
		'tel': '',
		'contact': ''
	}];
	rate_usd;
	rate_eur;

	certificate_;

	step;
	data = {
		nombre_razon_social: '',
		direccion_fiscal: '',
		rfc_asegurado: '',
		contratante: '',
		direccion_contratante: '',
		rfc_contratante: '',
		descripcion_mercancia: ''
	};

	categories = {
		metodo: false,
		contratante: false,
		cliente: false,
		mercancia: false,
		transporte: false,
		valor: false,
		tarifa: false,
		certificado: false
	};

	quote_status = [
		{ value: 0, name: 'Incompleta' },
		{ value: 1, name: 'Pendientes' },
		{ value: 2, name: 'Emitidas' },
		{ value: 3, name: 'Canceladas' }
	];

	security_measures = []

	valores_moneda = {
		mxn: 1,
		usd: 19.21,
		euro: 22.21
	};

	gastos_adicionales = 0;

	quote: any = {
		tipo_mercancia: null,
		compania: { id: null },
		descripcion_mercancia: null,
		tipo_embalaje: null,
		cobertura_contenedor: false,
		tipo_contenedor: null,
		medidas_seguridad: null,
		numero_pedimento_referencia: null,
		numero_sello: null,
		numero_contenedor: null,
		rc_errores_omisiones: false,
		valor_mercancia: null,
		flete: null,
		impuestos_nacionales: null,
		lucro_cesante: 0,
		subtotal: null,
		gastos_adicionales: false,
		total: null,
		tipo_cambio_eur: this.valores_moneda.euro,
		tipo_cambio_mxn: this.valores_moneda.mxn,
		tipo_cambio_usd: this.valores_moneda.usd,
		prima_venta: null,
		linea_transportista: null,
		transporte_nacional: false,
		importacion: false,
		exportacion: false,
		operador: null,
		importacion_desde: '',
		importacion_hasta: '',
		exportacion_desde: null,
		exportacion_hasta: null,
		observaciones: null,
		solicitado_por: null,
		valor_mercancia_exchange: null,
		flete_exchange: null,
		impuestos_nacionales_exchange: null,
		insured: null,
		result_subtotal_peso: null,
		result_subtotal_dollar: null,
		result_total_peso: null,
		result_total_dollar: null,
		result_gran_total_peso: null,
		result_gran_total_dollar: null,
		document_file: null,
		documents: null,
	};

	type_product = [
		{ value: 1, name: 'Mercancía General' },
		{ value: 2, name: 'Vehiculos' },
		{ value: 3, name: 'Refrigeradores' },
		{ value: 4, name: 'Electrónicos' },
		{ value: 5, name: 'Químicos' },
		{ value: 6, name: 'Romplibles' }
	];

	type_packaging = [
		{ value: 1, name: 'Contenedor' },
		{ value: 2, name: 'Pallets' },
		{ value: 3, name: 'Caja cartón' },
		{ value: 4, name: 'Carga suelta' },
		{ value: 6, name: 'Caja seca' },
		{ value: 5, name: 'Otro' }
	];

	companies = [
		{ value: 1, name: 'JAH' },
		{ value: 2, name: 'Banorte' }
	];

	coverage = [
		{ value: 1, name: 'Total Loss' },
		{ value: 2, name: 'Full Cover' },
		{ value: 3, name: 'Full Cover Plus' }
	];

	tasa = [
		{ value: 1, name: '22%' }
	];

	c_armados = [
		{ value: 1, name: 'SI' },
		{ value: 2, name: 'NO' }
	];

	country_mexico = {
		name: "México",
		state: "1",
		code: "",
		country: "86"
	};

	container = [];
	containers = [];

	option_contractor = 1;
	contractor_filter;
	contract_info;
	contractor_selected;
	load_selected;

	quote_1;
	quote_2;
	quote_3;
	step_ = 1;

	user_info;
	admin = false; // variable para indicar si es usuario de atencion a clientes
	client_data;

	// variable si es admin full (usuario administrador)
	admin_full: boolean = false;

	// variable si es super user (usuario super administrador)
	superuser: boolean = false;

	// variable para indicar si es usuario cliente
	usuarioCliente: boolean = false;

	/** banderas indicativas de inputs modificados */
	tasa_venta_modificada: boolean = false; // bandera para indicar si se ha modificado el input de la tasa de venta
	pais_origen_modificado: boolean = false; // bandera para indicar si se ha modificado el input del pais de origen
	pais_destino_modificado: boolean = false; // bandera para indicar si se ha modificado el input del pais de destino

	// contenedores
	contenedores = [
		{ nombre: 'Estándar Seco 20\'', monto: 8000, moneda: 'USD', primaMinima: 3.6 },
		{ nombre: 'Estándar Seco 40\'', monto: 12000, moneda: 'USD', primaMinima: 5.4 },
		{ nombre: 'High Cube Seco 40\'', monto: 12000, moneda: 'USD', primaMinima: 5.4 },
		{ nombre: 'Flat', monto: 40000, moneda: 'USD', primaMinima: 20 },
		{ nombre: 'Open Side', monto: 40000, moneda: 'USD', primaMinima: 20 },
		{ nombre: 'Open Top', monto: 35000, moneda: 'USD', primaMinima: 17.5 },
		{ nombre: 'Reefer 20\'', monto: 35000, moneda: 'USD', primaMinima: 17.5 },
		{ nombre: 'Reefer 40\'', monto: 50000, moneda: 'USD', primaMinima: 25 },
		{ nombre: 'Isotanque', monto: 50000, moneda: 'USD', primaMinima: 25 },
	];
	contenedorSelect = this.contenedores[0]; // contenedor seleccionado actual (por defecto el primero)

	// enum contenedor
	enumContenedor = {
		Contenedor: 'Contenedor', // Contenedor
		MaqGeneral: 'Maquinaria en general', // Maquinaria en general -> remover
	};

	// enum aseguradora
	enumAseguradora = {
		ChubbUsd: 'CHUBB USD'
	};

	// gastos_adicionales;
	gas_add;
	quote_selected;

	data_insured = {
		nombre: '',
		email: '',
		telefono: '',
		direccion: '',
		rfc: '',
		pais: '',
		ciudad: '',
		grupo_id: null
	};
	insured_option;
	client_option;

	servicesId;
	prima_minima = false;

	load_selected_branch = 1;

	cliente_seleccionado = {
		'id': 0,
		'mercancias': [],
		'option': 0,
		'nombre': ''
	};

	jah_transport =  [
		{ value: 1, name: 'Aéreo', limite: 1000000 },
		{ value: 2, name: 'Marítimo', limite: 1000000 },
		{ value: 4, name: 'Terrestre', limite: 500000 },
	];

	jah_transport_type : any;

	countries;
	get_rates_values;

	phone;

	JAH_ID;
	percent_value_ = false;

	currency_pattern = '^(\d{1,3})(,\d{1,3})*(\.\d{1,})?$';

	emition_process = false;

	responsive = false;

	copy = [];

	dataServiceCopy = [];
	f_data = {
		file: null,
		file_: {}
	};
	proceso_documental = false;
	metodo_quote;
	show_transporte = true;
	filename = '';
	load=false;

	quote_load=null;

	aseguradoIndexSel: number = null;

	acepto_adicional = true;
    acepto_adicional_type = "1";

	inputCorreoAseguradoValido = true;


    @HostListener('window:resize') onResize() {

      if(window.innerWidth <= 999) {
        this.responsive = true;
      } else if(window.innerWidth >= 1000) {
        this.responsive = false;
      }
    }

	@Input()
	set esc_step(data: any) {
		this.step = data;
		this.step_ = data;
	}

	@Input()
	set contractorsDatasource(data: any) {
		if (data) {
			this._contractors_data = data;
			this.showContractInfo(data[0]);
			if(localStorage.duplicate){
				this.quote_load = JSON.parse(localStorage.contractor_selected)
				let contractors = this._contractors_data
				let contractor_selected =  null;
				for (let i in contractors) {
					if(contractors[i].id == this.quote_load.contratante){
						contractor_selected =  contractors[i];

					}
				}
				if (contractor_selected){
					this.selectContractor_(contractor_selected)
				}
				this.next_of_product(2)

			}
		}
	}

	@Input()
	set contractorAdded(data: any) {

		if (data) {

			this.contractor_selected = data;
			localStorage['contractor_selected'] = JSON.stringify(this.contractor_selected);
			localStorage['contractor_selected_'] = JSON.stringify(this.contractor_selected);
			this.changeStep(2);
		}

	}

	@Input()
	set responseQuote(data: any) {
		this.contractor_selected = null;
		this.quote_1 = null;
		this.quote_2 = null;
		this.quote_3 = null;
		this.clearQuote();
	}

	@Input()
	set resultFullList(data: any) {
		if (data) {
			this._quotes_data = data
		}
	}

	@Input()
	set pagConfig(data: any) {
		this._pag_config = [];
		this.totalPages = [];
		this._pag_config = data;

		if (this._pag_config) {
			this.pages_ = Math.ceil(this._pag_config.count / 10);
			for (var i = 0; i < this.pages_; i++) {
				this.totalPages.push(i + 1);
			}
		}
	}

	@Input()
	set resultExchange(data: any) {

		if (data) {
			this.rate_exchange = data;
			this.rate_exchange_mxn = 1;
			this.rate_exchange_usd = parseFloat(data.dolar);
			this.rate_exchange_eur = parseFloat(data.euro);
		}
	}

	@Input()
	set insuredList(data: any) {

		if (data) {
			this._insuredList = data;
			console.log(data)
			if (this._insuredList.length==1){
				this.quote.insured =this._insuredList[0];
			}
			if(localStorage.duplicate){
				this.quote_load = JSON.parse(localStorage.contractor_selected)
				if(this.quote_load.quote_type ==1){
					for (let i in this._insuredList) {
						if(this._insuredList[i].id == this.quote_load.asegurado){
							this.quote.insured =  this._insuredList[i];

						}
					}
					this.next_of_product(8)
				}
			}
		}
	}

	@Input()
	set clientGroup(data: any) {
		if (data) {

			this.client_data = data;
		}
	}

	@Input()
	set getClient(data: any) {
		if (data) {
			if (this.proceso_documental) {
				this.quote.insured = data;
				this.quote.insured.name = data.nombre;

				let datosCadena = {
					cadena: data.nombre,
					grupo: this.cliente_seleccionado.id
				}

				this.getListInsured.emit(datosCadena);

				this.ingresaIndiceAsegurado(0);

			} else {
				this.quote.insured = data;
				this.quote.insured.name = data.nombre;
				this.categories.cliente = false;
				this.categories.mercancia = true;
			}
			this.phone = '';
			this.data_insured = {
				nombre: '',
				email: '',
				telefono: '',
				direccion: '',
				rfc: '',
				pais: '',
				ciudad: '',
				grupo_id: null
			};
			this.insured_option = 2;
			localStorage.removeItem('insured_selected');
		}
	}

	@Input()
	set countries_list(data: any) {
		if (data) {
			this.countries = data;
		}
	}

	@Input()
	set containersList(data: any) {
		if (data) {
			for (let i in data) {
				let item = (data[i].type).replace('PULGADAS', 'PIES');
				data[i].type = item;
			}

			this._containers_list = data;
		}
	}

	@Input()
	set coveragesList(data: any) {
		if (data) {
			// this._coverages_list = [
			// 	{ 'name': data['0'] },
			// 	{ 'name': data['1'] },
			// 	{ 'name': data['2'] },
			// 	{ 'name': data['4'] }
			// ];

			/**
			 * "json": [
				"Door to door",
				"Port to port",
				"Port to door",
				"Port to airport",
				"Door to port",
				"Airport to door",
				"Door to airport",
				"Airport to port",
				"Airport to airport"
        		]
			 */

			// se colocan todas las coberturas disponibles (se incluyen las opciones de airport)
			this._coverages_list = [
				{ 'name': data['0'] },
				{ 'name': data['1'] },
				{ 'name': data['2'] },
				{ 'name': data['3'] },
				{ 'name': data['4'] },
				{ 'name': data['5'] },
				{ 'name': data['6'] },
				{ 'name': data['7'] },
				{ 'name': data['8'] },
			];

			if(localStorage.duplicate){
				this.quote_load = JSON.parse(localStorage.contractor_selected)
				if (this.quote_load.quote_type==1){
					// let index=0;
					// if(this.quote_load.cobertura_door_to_door.toLowerCase()=='door to door'){
					// 	index = 0;
					// } else if(this.quote_load.cobertura_door_to_door.toLowerCase()=='port to port'){
					// 	index = 1;
					// }else if(this.quote_load.cobertura_door_to_door.toLowerCase()=='port to door'){
					// 	index = 2;
					// }else if(this.quote_load.cobertura_door_to_door.toLowerCase()=='door to port'){
					// 	index = 3;
					// }
					// this.quote.trayecto =this._coverages_list[index];

					// modificacion para que se seleccione la cobertura que se guardo en la cotizacion con el objeto de cobertura (se incluyen las opciones de airport)
					this.quote.trayecto = this._coverages_list.find((item: any) => {
						return item.name.toLowerCase() == this.quote_load.cobertura_door_to_door.toLowerCase();
					});
				    

			}

				//let trayecto = this.quote_load.cobertura_door_to_door
				//this.quote.trayecto ={'name':trayecto.charAt(0).toUpperCase() + trayecto.slice(1).toLowerCase()};
				this.quote.medidas_seguridad_option =this.quote_load.medidas_seguridad;
				//this.quote.documento = this.quote_load.numero_documento_contenedor;
			}
		}
	}

	jah_commodities;
	complete_list_coverages = false;

	@Input()
	set commodityList(data: any) {
		if(!this.quote.documents){
			this.quote.documents =[{'document':'', 'filename':'', 'contenedor':''}];
		}
		if (data) {

			if (data.results) {
				data = data.results;
			}

			if (this.quote.compania == this.JAH_ID || this.quote.compania.id == this.JAH_ID || data.name == "jah") {

				if (data.name == "jah") {

					this.jah_commodities = data.data;

				} else {

					for (let i in data) {
						data[i].name_ = data[i].name;
					}

					this._commodity_list = data;
				}

			} else {
				for (let i in data) {
					data[i].name_ = data[i].name;
				}
				this._commodity_list = data;
			}

			if (this._commodity_list.length && this.jah_commodities) {

				for (let i in this._commodity_list) {
					let comm_item = this._commodity_list[i];

					for (let k in this.jah_commodities) {

						let jah__item = this.jah_commodities[k];

						if ((jah__item.name_.toUpperCase()).indexOf(comm_item.name_.toUpperCase()) != -1) {

							this._commodity_list[i]['product'] = jah__item.product;
							this._commodity_list[i]['quotation'] = jah__item.quotation;
							this._commodity_list[i]['id'] = jah__item.id;
							for (let f in this._commodity_list[i].paquete_mercancia) {

								let pack = this._commodity_list[i].paquete_mercancia[f];
								let pack_name = (pack.cobertura).toUpperCase();

								if (pack_name == 'TOTAL LOSS') {
									pack.cover = 1;
								} else if (pack_name == 'FULL COVER') {
									pack.cover = 2;
								} else if (pack_name == 'FULL COVER PLUS') {
									pack.cover = 3;
								}

							}
						}else{
							if(comm_item.name_ == 'Electrónicos'){
								if ((jah__item.name_.toUpperCase()).indexOf('Electrónicos'.toUpperCase()) != -1) {
									this._commodity_list[i]['product'] = jah__item.product;
									this._commodity_list[i]['quotation'] = jah__item.quotation;
									this._commodity_list[i]['id'] = jah__item.id;
									for (let f in this._commodity_list[i].paquete_mercancia) {

										let pack = this._commodity_list[i].paquete_mercancia[f];
										let pack_name = (pack.cobertura).toUpperCase();

										if (pack_name == 'TOTAL LOSS') {
											pack.cover = 1;
										} else if (pack_name == 'FULL COVER') {
											pack.cover = 2;
										} else if (pack_name == 'FULL COVER PLUS') {
											pack.cover = 3;
										}

									}
								}
							} else if(comm_item.name_ == 'Rompibles'){
								if ((jah__item.name_.toUpperCase()).indexOf('Menaje'.toUpperCase()) != -1) {
									this._commodity_list[i]['product'] = jah__item.product;
									this._commodity_list[i]['quotation'] = jah__item.quotation;
									this._commodity_list[i]['id'] = jah__item.id;
									for (let f in this._commodity_list[i].paquete_mercancia) {

										let pack = this._commodity_list[i].paquete_mercancia[f];
										let pack_name = (pack.cobertura).toUpperCase();

										if (pack_name == 'TOTAL LOSS') {
											pack.cover = 1;
										} else if (pack_name == 'FULL COVER') {
											pack.cover = 2;
										} else if (pack_name == 'FULL COVER PLUS') {
											pack.cover = 3;
										}

									}
								}
							}
						}

					}
				}

				this.complete_list_coverages = true;
			}

			if (this._commodity_list.length >= 1) {
				let tm_selected = this._commodity_list[0]
				if(localStorage.duplicate){
					this.quote_load = JSON.parse(localStorage.contractor_selected)
                	for (let cl in this._commodity_list){
						if(this._commodity_list[cl].id == this.quote_load.tipo_mercancia.id){
							tm_selected =this._commodity_list[cl];
						}

					}


				}else {
                	for (let cl in this._commodity_list){
						if(this._commodity_list[cl].name == 'Mercancía general'){
							tm_selected =this._commodity_list[cl];
						}

					}
				}
				this.quote.tipo_mercancia = tm_selected;
				this.selectCommodity(tm_selected);

				if (this.quote.transporte) {
					this.type_transport();
				}
			}

		}

		this.removerContenedorMercancia(); // remueve el contenedor de la lista de commodities

	}

	/**
	 * Remueve el contenedor de la lista de commodities
	 */
	private removerContenedorMercancia() {
		let certificado: any = this.quote;
		let metodo: any = this.metodo_quote;
		
		let enumMetodo = {
			Declaracion: 'Declaración'
		};

		if (certificado && metodo) {
			if ((certificado.compania && certificado.compania.name != this.enumAseguradora.ChubbUsd) || (metodo != enumMetodo.Declaracion) || !this.admin_full) {
				// en la lista de commodities, buscar el que tenga el nombre de 'Contenedor' y removerlo de la lista
				// el contenedor solo se debe de mostrar en chubb usd y en el metodo de declaracion
				this._commodity_list = this._commodity_list.filter((item: any) => {
					return item.name != this.enumContenedor.Contenedor;
				});
			}
		}
	}

	eliminarDiacriticos(texto) {
    	return texto.normalize('NFD').replace(/[\u0300-\u036f]/g,"");
	}


	@Input()
	set spcifyRatesList(data: any) {

		if (data) {

			let dataspurce;


			if (this.quote.tipo_mercancia) {

				if (this.quote.tipo_mercancia['product'] == '1') {
					if(data[0].productList.length) {
						dataspurce = data[0].productList[0].coverList;
					} else {
						dataspurce = data[0].productList[1].coverList;
					}

				} else {
					if(data[0].productList.length) {
						dataspurce = data[0].productList[0].coverList;
					} else if(data[1].productList.length) {
						dataspurce = data[1].productList[0].coverList;
					}

				}

				for (let i in this.quote.tipo_mercancia.paquete_mercancia) {
					let item_quote = (this.quote.tipo_mercancia.paquete_mercancia[i].cobertura).toUpperCase();
							// console.log('item_quote', item_quote);

					for (let k in dataspurce) {
						let item_data = (dataspurce[k].name).toUpperCase();

						if (item_quote == item_data) {

							// console.log('item_quote', item_quote);

							if (this.quote.cobertura_list.length>1){
								this.quote['cobertura'] = {};
							}
							this.quote.tipo_mercancia.paquete_mercancia[i]['deductible'] = dataspurce[k].deductible;
							this.quote['cobertura']['deductible'] = dataspurce[k].deductible;
							this.quote.tipo_mercancia.paquete_mercancia[i]['premium'] = dataspurce[k].premium;
							this.quote['cobertura']['premium'] = dataspurce[k].premium;
						}


					}
				}
			}

			this.get_rates_values = 1;

		}
	}

	@Input()
	set resultQuotes(data: any) {

		if (data) {

			this.success_certificate_id = data.id;
			if (data.id) {
				this.categories.certificado = true;

				this.user_['contact'] = '';
				if(this.user_info) {

					this.user_['contact'] = this.user_info.first_name + ' ' + this.user_info.last_name;
				}

			}
			if (this.clear_form){
				this.clearQuote()
			}
		}
	}

	@Input()
	set servicesData(data: any) {
		if (data) {
			let aseguradoras = data.results;
			let array_aseguradoras = [];
			this.dataServiceCopy = [];
			if(aseguradoras.length != 0){
				for(var i = 0; i < aseguradoras.length; i++){
					// actualizacion para HDI
					array_aseguradoras.push(aseguradoras[i]);
					this.dataServiceCopy.push(aseguradoras[i]);
					// if(aseguradoras[i].name != "HDI"){
					// 	array_aseguradoras.push(aseguradoras[i])
					// 	this.dataServiceCopy.push(aseguradoras[i])
					// }
				}
				this.data_services = array_aseguradoras;
				if (this.data_services.length == 1) {
					this.quote.compania = this.data_services[0];
					this.changeCompany(this.data_services[0]);
				}else{
					if(localStorage.duplicate){
						this.quote_load = JSON.parse(localStorage.contractor_selected)
						let contractor_selected =  null;
						for (let i in this.data_services) {
							if(this.data_services[i].id == this.quote_load.service){
								this.quote.compania =  this.data_services[i];
								this.changeCompany(this.data_services[i]);

							}
						}

					}
				}
			}
		}
	}

	@Input()
	set resultEmission(data: any) {
		if (data) {
			if (this.success_certificate) {
				this.success_certificate = data;
				if (this.success_certificate['message'] == 'Success') {
					window.open(this.success_certificate['path'], '_blank');

				}
			}
		}
	}

	cols_desde;
	cols_hasta;

	@Input()
	set dataDesde(data: any) {
		if (data) {
			// console.log('desde', data);
			this.quote.origen_ciudad = data.municipio;
			this.quote['origen_estado'] = data.estado.name;
			this.cols_desde = data.colonias;
			if (this.cols_desde.length == 1) {
				this.quote.origen_colonia = this.cols_desde[0].name;
			}
			else{
				if(this.quote_load){
					for ( let i in this.cols_desde){
						if(this.cols_desde[i].name == this.quote_load.desde.address.split(",")[1].trim()){
							this.quote.origen_colonia = this.cols_desde[i].name;
						}
					}
				}
			}

		}
	}

	@Input()
	set dataHasta(data: any) {
		if (data) {
			// console.log('hasta', data);
			this.quote.destino_ciudad = data.municipio;
			this.quote['destino_estado'] = data.estado.name;
			this.cols_hasta = data.colonias;
			if (this.cols_hasta.length == 1) {
				this.quote.destino_colonia = this.cols_hasta[0].name;
			}
			else{
				if (this.quote_load){
					for ( let i in this.cols_hasta){
						if(this.cols_hasta[i].name == this.quote_load.hasta.address.split(",")[1].trim()){
							this.quote.destino_colonia = this.cols_hasta[i].name;
						}
					}
				}
			}
		}
	}

	@Input()
	set emitionRequest(data: any) {
		if(data) {
			// emitirQuotes
			// this.loader_yellow = false;
			this.emition_process = false;
			this.clearQuote();

		}
	}

	@Input()
	set deleteResult(data: any) {
		if(data) {
			// console.log('daaaaaa', data);
			this._insuredList.splice(data.index, 1)

			if (this.quote.insured) {
				if(this.quote.insured.nombre === data.nombre) {
					this.quote.insured = null
				}
			}

			// ! despues de eliminar al asegurado, si se cambia de pestaña y se regresa vuelve a mandar el mensaje de eliminado
			console.warn('Asegurado eliminado: ', data.nombre);
			// swal.fire(
		    //   '¡Listo!',
		    //   'Asegurado eliminado.',
		    //   'success'
		    // );
		}
	}

	@Input()
	set editResult(data: any) {
		if(data) {
			// console.log('}}}}}}}}}}}}}', data);
			this._insuredList[data.index] = data;
			this.insured_option = 2;
		}
	}

	@Output() returnMenu = new EventEmitter();
	@Output() contractorsFilter = new EventEmitter();
	@Output() addContractor = new EventEmitter();
	@Output() saveQuote = new EventEmitter();
	@Output() getFullList = new EventEmitter();
	@Output() getContractors = new EventEmitter();
	@Output() saveStatus = new EventEmitter();
	@Output() reqInsured = new EventEmitter();
	@Output() getRateExchange = new EventEmitter();
	@Output() getListInsured = new EventEmitter();
	@Output() getCountries = new EventEmitter();
	@Output() spcifyRates = new EventEmitter();
	@Output() cargaQuotes = new EventEmitter();
	@Output() sendPdfData = new EventEmitter();
	@Output() getCommonCom = new EventEmitter();
	@Output() getJahCommodities = new EventEmitter();
	@Output() emitirQuotes = new EventEmitter();
	@Output() getServices = new EventEmitter();
	@Output() cpParam = new EventEmitter();
	@Output() deleteIns = new EventEmitter();
	@Output() editIns = new EventEmitter();

	constructor(private _fb: FormBuilder, private nnotifications: NotificationsService, ) {

		// this._swal2.success({ title: 'This is a alert' }); private _swal2: SweetAlertService

		// colocar bandera de super usuario
		if (localStorage['superuser'] && localStorage['superuser'] == '1'){ this.superuser = true; }

		// colocar la variable de full admin del local storage -> usuario administrador
		if (localStorage['admin_full'] == 'true'){ this.admin_full = true; }

		// colocar la variable de cliente del local storage -> usuario atencion a clientes
		// se utiliza el local storage de admin porque es el unico que no aparece cuando se logea el cliente
		if (!localStorage['admin']){ this.usuarioCliente = true; }

		this.bsValue = ' ';
		this.startMinDate = new Date();
		if (localStorage['admin_full']=='true'){
			this.startMinDate = new Date(2000,0,1);
		} else if(localStorage['admin']=='true'){
			this.startMinDate.setDate(this.startMinDate.getDate() - 7);
		}

		this.startMaxDate = new Date();
		this.startMaxDate.setDate(this.startMaxDate.getDate() + 120);
		this.clearQuote();
		if(localStorage.from_list){
			localStorage.removeItem('from_list');
		} else{
			localStorage.removeItem('contractor_selected');
			localStorage.removeItem('duplicate');
		}


	    if(window.innerWidth <= 999) {
	       this.responsive = true;
	    } else if(window.innerWidth >= 1000) {
	       this.responsive = false;
	    }

	}

	insured;

	ngOnInit() {

		// this.bsValue = new Date();
		// this.form = this._fb.group({
	 //        type: 'success',
	 //        title: 'This is just a title',
	 //        content: 'This is just some content',
	 //        timeOut: 5000,
	 //        showProgressBar: false,
	 //        pauseOnHover: true,
	 //        clickToClose: true,
	 //        animate: 'scale'
	 //      });

		// console.log('_fb',this._fb);

		// console.log('form',this.form);


		this.getCountries.emit('ok');

		if (sessionStorage['user_info']) {

			this.user_info = JSON.parse(sessionStorage['user_info']);
			this.user_['email'] = this.user_info.email;
		}

		if (localStorage['step_']) {
			this.step_ = parseInt(localStorage['step_']);
			this.step = this.step_;
		} else {
			this.step = 1;
			localStorage['step_'] = this.step_;
		}


		if (localStorage['admin']) {
			this.admin = true;
			this.categories = {
				metodo: true,
				contratante: false,
				cliente: false,
				mercancia: false,
				transporte: false,
				valor: false,
				tarifa: false,
				certificado: false
			};
		} else {
			//this.categories.cliente = true;
			this.insuredAction(2);
		}

		if (localStorage['client_group']) {
			this.client_data = JSON.parse(localStorage['client_group']);
		}

		if (localStorage['data']) {
			this.data = JSON.parse(localStorage['data']);
		}

		if (localStorage['contractor_selected']) {
			if (localStorage['contractor_selected'] !== 'undefined') {
				this.contractor_selected = JSON.parse(localStorage['contractor_selected_']);
			}
		}

		if (localStorage['quote_1']) {
			this.quote = JSON.parse(localStorage['quote_1']);
			this.quote_1 = this.quote;
		}

		if (localStorage['quote_2']) {
			this.quote = JSON.parse(localStorage['quote_2']);
			this.quote_1 = null;
			this.quote_2 = this.quote;
		}

		if (localStorage['quote_3']) {
			this.quote = JSON.parse(localStorage['quote_3']);
			this.quote_1 = null;
			this.quote_2 = null;
			this.quote_3 = this.quote;

			if (this.quote.importacion) {

				let _importacion_desde = this.quote.importacion_desde.substring(0, 10);
				let _imprt_desde = (_importacion_desde).split('-');

				let _importacion_hasta = this.quote.importacion_hasta.substring(0, 10);
				let _imprt_hasta = (_importacion_hasta).split('-');

				this.quote.importacion_desde = _imprt_desde[2] + '/' + _imprt_desde[2] + '/' + _imprt_desde[0];
				this.quote.importacion_hasta = _imprt_hasta[2] + '/' + _imprt_hasta[2] + '/' + _imprt_hasta[0];
			}

			if (this.quote.exportacion) {

				let _exportacion_desde = this.quote.exportacion_desde.substring(0, 10);
				let _exprt_desde = (_exportacion_desde).split('-');

				let _exportacion_hasta = this.quote.exportacion_hasta.substring(0, 10);
				let _exprt_hasta = (_exportacion_hasta).split('-');

				this.quote.exportacion_desde = _exprt_desde[2] + '/' + _exprt_desde[2] + '/' + _exprt_desde[0];
				this.quote.exportacion_hasta = _exprt_hasta[2] + '/' + _exprt_hasta[2] + '/' + _exprt_hasta[0];
			}

		}

		if (localStorage['step']) {
			this.step = parseInt(localStorage['step'])
		}

		this.getRateExchange.emit('ok');

		this.quote.valor_mercancia = 0;
		this.quote.valor_type = 'mxn';
		this.quote.flete = 0;
		this.quote.flete_type = 'mxn';
		this.quote.impuestos_nacionales = 0;
		this.quote.impuestos_type = 'mxn';
		this.quote.lucro_cesante = 0;
		this.quote.subtotal = 0;
		this.quote.operacion = 0;
		this.quote.operacion_type = 'mxn';
		this.quote.total_asegurado = 0;
		this.quote.currency_total = 'mxn';

		this.quote.prima_check = false;
		this.quote.prima_eo_check = false;
		this.quote.prima_contenedor_check = false;
		this.quote.total_check = false;


		if(localStorage['duplicate']){
			//localStorage.removeItem('duplicate');
			this.quote_load = JSON.parse(localStorage.contractor_selected)
			if (this.quote_load.quote_type==2){
				this.documentalCotizacor();
				this.contractorFilter('');

				this.quote =  this.quote_load;

			}else {
				this.finishContractorSelection();
				this.contractorFilter({'cadena':this.quote_load.contratante_info.nombre});
				this.quote =  this.quote_load;
				this.quote.numero_pedimento_referencia = null;
				this.quote.numero_sello = null;
				this.quote.documento = null;
			}

		}
	}

	notify(parType, parTitle, parContent) {
		// console.log('alksdjf', this._notifications);

	 //    // const temp = this.form.getRawValue();
	 //    console.log(parType);
	 //    console.log(parTitle);
	 //    console.log(parContent);

	 //    const toast = this._notifications.success('Item created!', 'Click to undo...', {
	 //      timeOut: 3000,
	 //      showProgressBar: true,
	 //      pauseOnHover: true,
	 //      clickToClose: false,
	 //      clickIconToClose: true
	 //    });

	 //    const title = parTitle;
	 //    const content = parContent;
	 //    const type = parType;
	 //    this._notifications.create('error', content, type);

	};

	deleteInsured(parInsured, index) {
		// console.log(parInsured);

		parInsured.index = index;

		// console.log(parInsured);

		swal.fire({
		  title: '¡Cuidado!',
		  text: "¿Seguro que desea eliminar el asegurado?",
		  type: 'warning',
		  showCancelButton: true,
		  confirmButtonColor: '#3085d6',
		  cancelButtonColor: '#d33',
		  confirmButtonText: 'Aceptar'
		  // cancelButtonText: 'Aceptar'
		}).then((result) => {
		  if (result.value) {

		  	parInsured.index = index;
		  	this.deleteIns.emit(parInsured);
		    // swal.fire(
		    //   'Deleted!',
		    //   'Your file has been deleted.',
		    //   'success'
		    // )
		  }
		})

	}

	name_option;
	editInsurance(item, index) {
		// console.log('........', item);
		this.data_insured = item;
		this.data_insured['index'] = index;
		this.phone = this.data_insured['telefono'];
		this.insured_option = 1;
		this.name_option = 'EDITAR ASEGURADO';
	}

	clearClient() {
		this.cliente_seleccionado = {
			'id': 0,
			'mercancias': [],
			'option': 0,
			'nombre': ''
		};
	}

	validateUntilDate(param) {
		this.quote.importacion_hasta = null;
		if(!this.quote.importacion_desde){ return; }
		this.endMinDate = new Date(this.quote.importacion_desde.getFullYear(), this.quote.importacion_desde.getMonth(), this.quote.importacion_desde.getDate());
		this.endMaxDate = new Date();
		this.endMaxDate.setDate(this.endMinDate.getDate() + 120);
	};

	col_by_zip_desde(param) {

		if (this.quote.tipo_operacion == 'transporte_nacional' || this.quote.origen_pais.country == '86') {

			if (String(param).length == 5) {
				let data = {
					zipCode: param,
					type: 1
				}
				this.cpParam.emit(data);
			} else {
				this.quote.origen_estado = '';
				this.quote.origen_ciudad = '';
				this.quote.origen_colonia = '';
				this.cols_desde = [];
			}
		}
	};

	col_by_zip_hasta(param) {
		if (this.quote.tipo_operacion == 'transporte_nacional' || this.quote.destino_pais.country == '86') {

			if (String(param).length == 5) {
				let data = {
					zipCode: param,
					type: 2
				}
				this.cpParam.emit(data);
			} else {

				this.quote.destino_estado = '';
				this.quote.destino_ciudad = '';
				this.quote.destino_colonia = '';
				this.cols_hasta = [];

			}
		}
	};

	selectContractor_(params) {
		this.cliente_seleccionado = params;
		this.cliente_seleccionado.option = 0;
		localStorage.cliente_seleccionado = JSON.stringify(params);
		this.getServices.emit(this.cliente_seleccionado);
	}

	finishContractorSelection() {
		this.data_services = [];
		this.data_services = this.dataServiceCopy;
		this.show_transporte = true;
		this.metodo_quote = 'Declaración';
		this.proceso_documental = false;

		let certificado: any = this.quote;
		let metodo: any = this.metodo_quote;
		
		if (certificado && metodo) {
			if (certificado.compania && certificado.compania.name == this.enumAseguradora.ChubbUsd) { // si se ha seleccionado chubb usd y el metodo es declaracion cargar nuevamente las mercancias
				let infoContratanteAseguradora = {
					grupo: this.cliente_seleccionado.id,
					service: this.servicesId,
				}
				this.getCommonCom.emit(infoContratanteAseguradora);
			}
		}

		if (!this.quote.insured){
			this.next_of_product(1)
		} else{
			this.categories.mercancia = true;
			this.categories.metodo = false;
			this.categories.cliente = false;

		}
	}

	selectClient() {
		// console.log(this.quote.insured);
		if (this.quote.insured) {
			this.categories.cliente = false;
			this.categories.mercancia = true;
		}
	}


	transport = [];
	selectCommodity(param) {
		this.quote.cobertura_list = [];
		this.quote.cobertura = '';

		this.quote.descripcion_mercancia = ''; // se restablece descripcion de la mercancia

		if (this.quote.compania) {

			this.transport = [];

			if (this.quote.compania.id == this.JAH_ID) {
				this.get_rates_values = 0;
				this.spcifyRates.emit(param);
			}
			// else {

			if (this.quote.tipo_mercancia.paquete_mercancia) {

				this.quote.tipo_mercancia.paquete_mercancia.map(function(item) {
					item.name = item.cobertura;
					return item;
				});
			}

			this.quote.cobertura_list = this.quote.tipo_mercancia.paquete_mercancia;

			if (this.quote.cobertura_list.length == 1) {
				this.quote.cobertura = this.quote.cobertura_list[0];
				this.changeCoberage();
			}


			if (param.service_name == 'JAH') {
				if (param.name == 'Mercancía general' || param.name == 'Vehículos' || param.name == 'Refrigerados' || param.name == 'Químicos') {
					this.transport = [
						{ value: 1, name: 'Aéreo', limite: 1000000 },
						{ value: 2, name: 'Marítimo', limite: 1000000 },
						{ value: 4, name: 'Terrestre', limite: 500000 },
						{ value: 6, name: 'Ferrocarril', limite: 500000 },
						{ value: 7, name: 'Multimodal', limite: 350000 }
					];

					this.jah_transport = [
						{ value: 1, name: 'Aéreo', limite: 1000000 },
						{ value: 2, name: 'Marítimo', limite: 1000000 },
						{ value: 4, name: 'Terrestre', limite: 500000 },
					];

				}
				if (param.name == 'Electrónicos') {
					this.transport = [
						{ value: 1, name: 'Aéreo', limite: 1000000 },
						{ value: 2, name: 'Marítimo', limite: 1000000 },
						{ value: 4, name: 'Terrestre', limite: 350000 },
						{ value: 6, name: 'Ferrocarril', limite: 350000 },
						{ value: 7, name: 'Multimodal', limite: 350000 }
					];
				}
				if (param.name == 'Rompibles') {
					this.transport = [
						{ value: 1, name: 'Aéreo', limite: 200000 },
						{ value: 2, name: 'Marítimo', limite: 200000 },
						{ value: 4, name: 'Terrestre', limite: 200000 },
						{ value: 6, name: 'Ferrocarril', limite: 150000 },
						{ value: 7, name: 'Multimodal', limite: 150000 }
					];
				}
			} else if (param.service_name == 'HDI') { // actualizacion para HDI
				this.transport = [
					{ value: 1, name: 'Aéreo', limite: 500000 },
					{ value: 2, name: 'Marítimo', limite: 500000 },
					{ value: 4, name: 'Terrestre', limite: 500000 },
					{ value: 6, name: 'Ferrocarril', limite: 500000 },
					{ value: 7, name: 'Multimodal', limite: 500000 }
				];
			} else if (param.service_name == 'GNP MXN') {
				this.transport = [
					{ value: 1, name: 'Aéreo', limite: 8000000 },
					{ value: 2, name: 'Marítimo', limite: 8000000 },
					{ value: 4, name: 'Terrestre', limite: 8000000 },
					{ value: 6, name: 'Ferrocarril', limite: 8000000 },
					{ value: 7, name: 'Multimodal', limite: 8000000 }
				];
			}else if (param.service_name == 'GNP USD') {
				this.transport = [
					{ value: 1, name: 'Aéreo', limite: 600000 },
					{ value: 2, name: 'Marítimo', limite: 600000 },
					{ value: 4, name: 'Terrestre', limite: 600000 },
					{ value: 6, name: 'Ferrocarril', limite: 600000 },
					{ value: 7, name: 'Multimodal', limite: 600000 }
				];
			}else if (param.service_name == 'CHUBB USD') {
				if (param.name == 'Mercancía general' ) {
					this.transport = [
						{ value: 1, name: 'Aéreo', limite: 300000 },
						{ value: 2, name: 'Marítimo', limite: 300000 },
						{ value: 4, name: 'Terrestre', limite: 300000 },
						{ value: 6, name: 'Ferrocarril', limite: 300000 },
						{ value: 7, name: 'Multimodal', limite: 300000 }
					];

				}
				else if (param.name == 'Mensajeria y Paqueteria') {
					this.transport = [
						{ value: 1, name: 'Aéreo', limite: 100000 },
						{ value: 2, name: 'Marítimo', limite: 100000 },
						{ value: 4, name: 'Terrestre', limite: 100000 },
						{ value: 6, name: 'Ferrocarril', limite: 100000 },
						{ value: 7, name: 'Multimodal', limite: 100000 }
					];
				}
				else if (param.name == 'Menaje de casa') {
					this.transport = [
						{ value: 1, name: 'Aéreo', limite: 150000 },
						{ value: 2, name: 'Marítimo', limite: 150000 },
						{ value: 4, name: 'Terrestre', limite: 150000 },
						{ value: 6, name: 'Ferrocarril', limite: 150000 },
						{ value: 7, name: 'Multimodal', limite: 150000 }
					];
				}
				else if (param.name == 'Mineral de cobre y/o telefonos celulares y/o joyeria') {
					this.transport = [
						{ value: 1, name: 'Aéreo', limite: 200000 },
						{ value: 2, name: 'Marítimo', limite: 200000 },
						{ value: 4, name: 'Terrestre', limite: 200000 },
						{ value: 6, name: 'Ferrocarril', limite: 200000 },
						{ value: 7, name: 'Multimodal', limite: 200000 }
					];
				}
				else if (param.name == 'Maquinaria en general') {
					this.transport = [
						{ value: 1, name: 'Aéreo', limite: 750000 },
						{ value: 2, name: 'Marítimo', limite: 750000 },
						{ value: 4, name: 'Terrestre', limite: 750000 },
						{ value: 6, name: 'Ferrocarril', limite: 750000 },
						{ value: 7, name: 'Multimodal', limite: 750000 }
					];
				} else if (param.name == this.enumContenedor.Contenedor) { // contenedor (chubb usd)

					/**
					 * CONTENEDOR
					 * Emular el comportamiento de la seleccion de transporte
					 * en el caso de que se seleccione contenedor
					 */

					this.transport = [
						{ value: 4, name: 'Terrestre', limite: 15000000 }, // limite no especificado
					];
					this.quote.transporte = this.transport[0]; // seleccionar terrestre
					this.type_transport(); // ejecutar como si se hubiera seleccionado el transporte

					// establecer la descripcion de la mercancia por el nombre del contenedor
					this.quote.descripcion_mercancia = this.contenedorSelect.nombre;

					// procesar la seleccion manual de la cobertura del trayecto y el tipo de embalaje
					this.aplicarCoberturaEmbalaje();

					// procesar el ingreso del valor de la mercancia
					this.aplicarValorMercancia();
				}

			}
			else if (param.service_name == 'CHUBB MXN') {
				if (param.name == 'Mercancía general' ) {
					this.transport = [
						{ value: 1, name: 'Aéreo', limite:  6000000 },
						{ value: 2, name: 'Marítimo', limite: 6000000 },
						{ value: 4, name: 'Terrestre', limite: 6000000 },
						{ value: 6, name: 'Ferrocarril', limite: 6000000 },
						{ value: 7, name: 'Multimodal', limite: 6000000 }
					];

				}
				else if (param.name == 'Mensajeria y Paqueteria') {
					this.transport = [
						{ value: 1, name: 'Aéreo', limite:  2000000 },
						{ value: 2, name: 'Marítimo', limite: 2000000 },
						{ value: 4, name: 'Terrestre', limite: 2000000 },
						{ value: 6, name: 'Ferrocarril', limite: 2000000 },
						{ value: 7, name: 'Multimodal', limite: 2000000 }
					];
				}
				else if (param.name == 'Menaje de casa') {
					this.transport = [
						{ value: 1, name: 'Aéreo', limite: 3000000 },
						{ value: 2, name: 'Marítimo', limite: 3000000 },
						{ value: 4, name: 'Terrestre', limite: 3000000 },
						{ value: 6, name: 'Ferrocarril', limite: 3000000 },
						{ value: 7, name: 'Multimodal', limite: 3000000 }
					];
				}
				else if (param.name == 'Mineral de cobre y/o telefonos celulares y/o joyeria') {
					this.transport = [
						{ value: 1, name: 'Aéreo', limite: 4000000 },
						{ value: 2, name: 'Marítimo', limite: 4000000 },
						{ value: 4, name: 'Terrestre', limite: 4000000 },
						{ value: 6, name: 'Ferrocarril', limite: 4000000 },
						{ value: 7, name: 'Multimodal', limite: 4000000 }
					];
				}
				else if (param.name == 'Maquinaria en general') {
					this.transport = [
						{ value: 1, name: 'Aéreo', limite:  15000000 },
						{ value: 2, name: 'Marítimo', limite: 15000000 },
						{ value: 4, name: 'Terrestre', limite: 15000000 },
						{ value: 6, name: 'Ferrocarril', limite: 15000000 },
						{ value: 7, name: 'Multimodal', limite: 15000000 }
					];
				} 
			}
			else if (param.service_name == 'CHUBB GLOBAL') { // actualizacion para CHUBB GLOBAL
				this.transport = [
					{ value: 1, name: 'Aéreo', limite: 1200000 },
					{ value: 2, name: 'Marítimo', limite: 1200000 },
					{ value: 4, name: 'Terrestre', limite: 400000 },
					{ value: 6, name: 'Ferrocarril', limite: 400000 },
					{ value: 7, name: 'Multimodal', limite: 400000 }
				];
			}
			else if (param.service_name == 'CHUBB INTERNACIONAL') { // actualizacion para CHUBB INTERNACIONAL
				this.transport = [
					{ value: 1, name: 'Aéreo', limite: 3000000 },
					{ value: 2, name: 'Marítimo', limite: 3000000 },
					{ value: 4, name: 'Terrestre', limite: 3000000 },
					{ value: 6, name: 'Ferrocarril', limite: 3000000 },
					{ value: 7, name: 'Multimodal', limite: 3000000 }
				];
			}
			if (localStorage.duplicate){
				this.quote_load = JSON.parse(localStorage.contractor_selected)
				for (let i in this.transport){
					if(this.transport[i].value == this.quote_load.rate.transport){
						this.quote.transporte =this.transport[i];
					}
				}
			}

		}


	}

	aplicarCoberturaEmbalaje() {
		// seleccionar la primera opcion de cobertura de _coverages_list en la variable de quote.trayecto
		this.quote.trayecto = this._coverages_list[0];

		// seleccionar la primera opcion de embalaje de type_packaging pero su propiedad value en la variable de quote.tipo_embalaje
		this.quote.tipo_embalaje = this.type_packaging[0].value;
	}

	aplicarValorMercancia() {
		// establecer el valor de la mercancia del contenedor en la variable de quote.valor_mercancia
		this.quote.valor_mercancia = this.contenedorSelect.monto;
		this.calculateSubtotalUltimate(); // calcular el subtotal y el total
		this.changeTotalPrima(); // calcular la prima y la prima neta

		// establecer el valor de la primaMinima del contenedor seleccionado en la variable de quote.prima
		this.quote.prima = this.contenedorSelect.primaMinima.toFixed(2);
		// establecer el valor de la primaMinima del contenedor seleccionado en la variable de quote.total_prima
		this.quote.total_prima = this.contenedorSelect.primaMinima.toFixed(2);

		// generar la tasa de la prima
		this.generarTasaVenta();

		// aplicar formato de monto a la variable de quote.valor_mercancia
		this.onAmountChange('valor_mercancia', this.quote.valor_mercancia, null)
	}

	correoAseguradoFocusOut(param: any) {
		let regex = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

		// Validar que el correo sea valido con el regex

		this.inputCorreoAseguradoValido = regex.test(param);

	}

	insuredAction(param) {

		if (!param) {
			param = '';
		}
		this.insured_option = param;

		if (param == 1) {
			// llamar listado de paises
		}

		if (param == 2) {
			// limpiar data_insured
			this.name_option = undefined;
			this.phone = '';
			this.data_insured = {
				nombre: '',
				email: '',
				telefono: '',
				direccion: '',
				rfc: '',
				pais: '',
				ciudad: '',
				grupo_id: '',
			};
			this.selectInsured();

			// hacer llamada lista de beneficiarios
			// this.getListInsured.emit('ok');
		}

	}

	selectInsured() {


		if (!this.insured) {
			this.insured = '';
		}

		let data = {
			cadena: this.insured,
			grupo: this.cliente_seleccionado.id
		}
		this.getListInsured.emit(data);
	}

	saveInsured() {
		if (this.inputCorreoAseguradoValido) {
			if(this.data_insured['url']) {
				// patch
				this.editIns.emit(this.data_insured);
				// console.log('++++++++++++', this.data_insured);

			} else {
				this.data_insured.grupo_id = this.cliente_seleccionado.id;
				this.data_insured['grupo'] = this.cliente_seleccionado.id;
				this.data_insured['group'] = this.cliente_seleccionado.id;
				this.reqInsured.emit(this.data_insured);
			}
			this.name_option = undefined;
			this.phone = '';
			this.data_insured = {
				nombre: '',
				email: '',
				telefono: '',
				direccion: '',
				rfc: '',
				pais: '',
				ciudad: '',
				grupo_id: '',
			};
		} else {
			swal.fire({
				title: 'Error',
				text: 'El correo ingresado no es válido',
				type: 'error',
				confirmButtonText: 'Aceptar'
			});
		}

	}

	contractorFilter(_contractor) {
		this.contractorsFilter.emit(_contractor);
	};

	changeStep(param) {
		switch (param) {
			case 1:
				// code...
				this.contractor_selected = null;
				this.step_ = 1;
				this.step = 1;
				this.returnToList();

				break;
			case 2:
				this.contractor_selected = JSON.parse(localStorage['contractor_selected_']);
				this.quote_1 = null;
				this.quote_2 = null;
				this.step_ = 2;
				break;
			case 3:
				this.contractor_selected = JSON.parse(localStorage['contractor_selected_']);
				this.quote_1 = this.quote;
				this.quote_2 = null;
				this.step_ = 3;
				break;
			case 4:
				this.contractor_selected = JSON.parse(localStorage['contractor_selected_']);
				this.quote_1 = null;
				this.quote_2 = this.quote;
				this.step_ = 4;
				break;
			case 5:

				this.getFullList.emit();
				this.contractor_selected = null;
				this.quote_1 = null;
				this.quote_2 = null;
				this.step = 5;
				this.step_ = 5;
				break;

			default:
				// code...
				break;
		}
	}

	referencia_;

	validate_referente() {
		this.referencia_ = true;
	}

	showContractInfo(param) {

		this.contract_info = null;
		this.contract_info = param;

		for (let i in this._contractors_data) {

			let item = this._contractors_data[i];

			if (param.id == item.id) {
				param.selected = true;
			} else {
				item.selected = false;
			}
		}
	};

	selectContractor(param) {
		this.contractor_selected = param;
		localStorage['contractor_selected'] = JSON.stringify(this.contractor_selected);
		localStorage['contractor_selected_'] = JSON.stringify(this.contractor_selected);
		this.changeStep(2);
		// this.changeForm(1);
	};

	selectContrQuote(param) {

		this.quote_selected = param;

		// for(let i in this.quote_selected.carga_quote_contratate) {

		// 	let item = this.quote_selected.carga_quote_contratate[i];

		// 	if(param.id == item.id) {
		// 		param.selected = true;
		// 		// this.load_selected = item;
		// 	} else {
		// 		item.selected = false;
		// 	}
		// }


		if (this.quote_selected.carga_quote_contratate.length) {
			this.load_selected = this.quote_selected.carga_quote_contratate[0];
			this.quote_selected.carga_quote_contratate[0].selected = true;
		}

	};

	changeSecurity(param) {

		if (param !== 'Otra') {
			this.quote.medidas_seguridad = this.quote.medidas_seguridad_option;
		} else {
			this.quote.medidas_seguridad = '';
			// this.quote.medidas_seguridad = this.quote.medidas_seguridad_option;
		}
	};

	selecteInsured() {

		console.log(this.quote.insured);


		// if(this.quote.insured) {
		// 	this.categories.cliente = false;
		// 	this.categories.mercancia = true;
		// }
	}

	ok_insurance(param) {
		this.quote.insured = param;
		// if(this.quote.insured) {
		this.categories.cliente = false;
		this.categories.mercancia = true;
		// }
	}

	selAseguradoDocumental(asegurado: any) {
		this.quote.insured = asegurado;
	}

	ingresaIndiceAsegurado(indice: number) {
		this.aseguradoIndexSel = indice;
	}

	selectLoad(param) {

		for (let i in this.quote_selected.carga_quote_contratate) {

			let item = this.quote_selected.carga_quote_contratate[i];

			if (param.id == item.id) {
				param.selected = true;
				this.load_selected = item;
			} else {
				item.selected = false;
			}
		}
	};

	onInputChange(event, param) {

		var newVal = event.replace(/\D/g, '');

		var rawValue = newVal;
		// if(backspace) {
		//   newVal = newVal.substring(0, newVal.length - 1);
		// }

		if (newVal.length == 0) {
			newVal = '';
		}
		else if (newVal.length <= 2) {
			newVal = newVal.replace(/^(\d{0,2})/, '$1');
		} else if (newVal.length <= 4) {
			newVal = newVal.replace(/^(\d{0,2})(\d{0,2})/, '$1/$2');
		} else {
			newVal = newVal.replace(/^(\d{0,2})(\d{0,2})(\d{0,4})/, '$1/$2/$3');
		}

		this.quote[param] = newVal;
	};

	onInputTelChange(event, parModel) {
		// remove all mask characters (keep only numeric)
		var newVal = event.replace(/\D/g, '');
		var rawValue = newVal;

		// if(backspace) {
		//   newVal = newVal.substring(0, newVal.length - 1);
		// }



		// don't show braces for empty value
		if (newVal.length == 0) {
			newVal = '';
		}
		// don't show braces for empty groups at the end
		else if (newVal.length <= 3) {
			newVal = newVal.replace(/^(\d{0,3})/, '($1)');
		} else if (newVal.length <= 3) {
			newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
		} else {
			newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(.*)/, '($1) $2-$3');
		}

		this.phone = newVal;
		this[parModel]['telefono'] = rawValue;
		// console.log(this[parModel]['telefono']);
		// console.log(this[parModel].telefono);
		// this[parModel] = rawValue;

	};

	addPercent(param) {

		if (parseFloat(this.quote[param]) == 0) {
			this.quote[param] = '0.00'
		}

		// console.log('adsfasdfasdf', String(this.quote[param])).indexOf('%'));

		if (String(this.quote[param]).indexOf('%') > -1) {
			this.quote[param] = (this.quote[param]).replace(/%/g, '');
		}

		if (String(this.quote[param]).length == 3) {
			this.quote[param] = this.quote[param] + '0'
		} else if (String(this.quote[param]).length > 4) {
			alert('La tasa de venta solo puede tener 2 decimales');
			this.quote[param] = String(this.quote.cobertura.tarifa)
		}

		this.quote[param] = this.quote[param] + '%';
		this.changeTotalPrima();

	}

	agregarPorcentaje() {
		const valorTasaVenta = String(this.quote.tasa_prima);
		const tieneSignoPorcentaje = valorTasaVenta.indexOf('%') > -1;

		if (tieneSignoPorcentaje) {
			this.quote.tasa_prima = valorTasaVenta.replace(/%/g, '');
		}

		const splitValorTasaVenta = valorTasaVenta.split('.');
		let tamanoDecimales = 0;

		if (splitValorTasaVenta.length >= 2 && typeof splitValorTasaVenta[1] === 'string') {
			tamanoDecimales = splitValorTasaVenta[1].length;
		}

		if (tamanoDecimales === 1) {
			this.quote.tasa_prima = `${this.quote.tasa_prima}0`;
		} else if (tamanoDecimales > 2) {
			alert('La tasa de venta solo puede tener 2 decimales');
			this.quote.tasa_prima = Number(valorTasaVenta).toFixed(2);
		}

		this.quote.tasa_prima = `${String(Number(this.quote.tasa_prima))}%`;

	}

	percentValue(param) {
		// let percetValue = this.quote.tasa_prima / 100;
		// console.log('percent_value_', this.percent_value_);
		// console.log('param', param);
		this.changeTotalPrima();

		// this.quote.tasa_prima = percetValue;
		// this.changeTotalPrima();
	}

	checkValue(event) {

		// console.log('event', event);
		if ((event.code).search('Digit') > -1 ||
			(event.code).search('Numpad') > -1 ||
			event.code == 'Backspace' ||
			event.code == 'Delete' ||
			event.code == 'ArrowLeft' ||
			event.code == 'Tab' ||
			event.code == 'Period' ||
			event.code == 'NumpadDecimal' ||
			event.code == 'ArrowRight') {
			return true;
		} else {
			return false;
		}
	};

	returnToList() {
		this.load_selected = null;
		this.quote_selected = null;
	};

	type_transport() {

		this.quote.modo_transporte = this.quote.transporte.value;

		for (var i = 0; i < this.transport.length; ++i) {
			if (this.quote.transporte.value == this.transport[i].value) {
				this.limite_despacho = this.transport[i].limite;
				// console.log(this.limite_despacho);
				// if(this.limite_despacho > 1 && this.limite_despacho <= 100000){
				// 	alert("volvo");
				// }else if(this.limite_despacho > 100001 && this.limite_despacho <= 150000){
				// 	alert("man");
				// }else if(this.limite_despacho > 150010){
				// 	console.log("benz");
				// 	this._notifications.create('success', 'Condición de seguridad', 'Se necesita GPS + Custodia física.', { timeOut: 3000 });
				// }
			}
		}

		if(this.quote.compania.name == 'HDI') {
			// se agrega GPS + Custodia virtual
			this.security_measures = [
				'GPS',
				'GPS + Custodia virtual',
				'GPS + Custodia física',
				'GPS + Custodia física "armada"',
				'Otra'
			];

		} else if (this.quote.compania.name == 'CHUBB GLOBAL') {
			this.security_measures = [
				'GPS',
				'GPS + Custodia virtual',
				'GPS + Custodia física',
				'Otra'
			];
		} else if (this.quote.compania.name == 'CHUBB INTERNACIONAL') {
			this.security_measures = [
				'GPS',
				'GPS + Custodia virtual',
				'GPS + Custodia física',
				'Otra'
			];
		} else {

			if(this.quote.transporte.name == 'Terrestre') {

					this.security_measures = [
						'GPS',
						'GPS + Custodia virtual',
						'GPS + Custodia física',
						'Otra'
					];

			} else {
				this.security_measures = [
					'Ninguna',
					'GPS',
					'GSP + Custodia virtual',
					'GPS + Custodia física',
					'Otra'
				];
			}
		}

	};

	clearQuote() {

		this.notify('warning', '¡OJO!', 'Esto es una prueba');
		//localStorage.removeItem('duplicate');
		//localStorage.removeItem('contractor_selected');

		this.quote = {
			tipo_mercancia: { mercancia: null, coberturas: [{ name: '', value: '' }] },
			compania: null,
			descripcion_mercancia: null,
			tipo_embalaje: null,
			cobertura_contenedor: false,
			tipo_contenedor: null,
			medidas_seguridad: null,
			numero_pedimento_referencia: null,
			numero_sello: null,
			numero_contenedor: null,
			rc_errores_omisiones: false,
			valor_mercancia: null,
			flete: null,
			impuestos_nacionales: null,
			lucro_cesante: 0,
			subtotal: null,
			gastos_adicionales: false,
			total: null,
			tipo_cambio_eur: this.valores_moneda.euro,
			tipo_cambio_mxn: this.valores_moneda.mxn,
			tipo_cambio_usd: this.valores_moneda.usd,
			prima_venta: null,
			linea_transportista: null,
			transporte_nacional: false,
			importacion: false,
			exportacion: false,
			operador: null,
			importacion_desde: '',
			importacion_hasta: '',
			exportacion_desde: '',
			exportacion_hasta: '',
			observaciones: null,
			solicitado_por: null,
			valor_mercancia_exchange: null,
			flete_exchange: null,
			impuestos_nacionales_exchange: null,
			insured: null,
			document_file: null,
			documents: [{'document':'', 'filename':''}]
		};

		this.containers = [];

		if (this.admin) {

			this.cliente_seleccionado = {
				'id': 0,
				'mercancias': [],
				'option': 0,
				'nombre': ''
			};

			this.categories = {
				contratante: false,
				metodo: true,
				cliente: false,
				mercancia: false,
				transporte: false,
				valor: false,
				tarifa: false,
				certificado: false
			};

		} else {

			this.categories = {
				contratante: false,
				metodo: true,
				cliente: false,
				mercancia: false,
				transporte: false,
				valor: false,
				tarifa: false,
				certificado: false
			};
		}

		this._insuredList = [];
		this._contractors_data = [];

	}

	primaVentaChange(param) {
		// console.log('param', param);
		let prima = parseFloat(this.quote.prima_venta);
		// console.log(prima)
		console.log('prima', prima);
		if (prima >= 1) {

			// console.log('------------');

			// this.quote.prima_venta = null;
			this.quote.prima_venta = 1;
		}

	}

	changeForm(param) {

		if (param == 1) {

			this.addContractor.emit(this.data);
			this.changeStep(1);

		} else if (param == 2) {

			this.changeStep(3);
			this.quote['contratante'] = this.contractor_selected.id;
			localStorage['quote_1'] = JSON.stringify(this.quote);
			this.quote_1 = this.quote;
			// this.calculateSubtotal(1,1);
			// this.calculateSubtotal(2,1);
			// this.calculateSubtotal(3,1);

		} else if (param == 3) {

			localStorage['quote_2'] = JSON.stringify(this.quote);
			this.quote_1 = null;
			this.quote_2 = this.quote;
			this.changeStep(4);

		} else if (param == 4) {

			// SAVE QUOTE
			// localStorage['quote_3'] = JSON.stringify(this.quote);
			// this.quote_3 = this.quote;
			// console.log('lksdjlkfsd');

			if (!this.quote.contratante) {

				this.quote.contratante = this.contractor_selected.id;
			}

			this.quote.gastos_adicionales = this.gastos_adicionales;

			this.quote.solicitado_por = this.user_info.first_name + ' ' + this.user_info.last_name;

			this.quote.valor_mercancia = (this.quote.valor_mercancia).replace(/,/g, '');

			if (this.quote.flete) {
				this.quote.flete = (this.quote.flete).replace(/,/g, '');
			} else {
				this.quote.flete = 0;
			}

			if (this.quote.impuestos_nacionales) {
				this.quote.impuestos_nacionales = (this.quote.impuestos_nacionales).replace(/,/g, '');
			} else {
				this.quote.impuestos_nacionales = 0;
			}

			if (this.quote.lucro_cesante) {
				this.quote.lucro_cesante = (this.quote.lucro_cesante).replace(/,/g, '');
			} else {
				this.quote.lucro_cesante = 0;
			}

			// this.quote.prima_venta = (this.quote.prima_venta).replace(/,/g, '');

			this.quote.valor_mercancia = parseFloat(this.quote.valor_mercancia);
			this.quote.prima_venta = parseFloat(this.quote.prima_venta);
			this.quote.subtotal = parseFloat(this.quote.subtotal);
			this.quote.total = parseFloat(this.quote.total);
			this.quote.flete = parseFloat(this.quote.flete);


			if (!this.quote.transporte_nacional) {
				this.quote.transporte_nacional = false;
			}


			if (this.quote.rc_errores_omisiones == null || this.quote.rc_errores_omisiones == undefined) {
				this.quote.rc_errores_omisiones = false;
			}

			if (this.quote.importacion) {
				this.quote.importacion_desde = this.parseDate(this.quote.importacion_desde);
				this.quote.importacion_hasta = this.parseDate(this.quote.importacion_hasta);
			} else {
				this.quote.importacion_desde = null;
				this.quote.importacion_hasta = null;
			}

			if (this.quote.exportacion) {
				this.quote.exportacion_desde = this.parseDate(this.quote.exportacion_desde);
				this.quote.exportacion_hasta = this.parseDate(this.quote.exportacion_hasta);
			} else {
				this.quote.exportacion_desde = null;
				this.quote.exportacion_hasta = null;
			}

			if (!this.quote.valor_mercancia_exchange) {
				this.quote.valor_mercancia_exchange = 1;
			}

			if (!this.quote.flete_exchange) {
				this.quote.flete_exchange = 1;
			}

			if (!this.quote.impuestos_nacionales_exchange) {
				this.quote.impuestos_nacionales_exchange = 1;
			}

			this.quote.status = 1;

			console.log('quote', this.quote);
			this.saveQuote.emit(this.quote);
			// LIMPIAR QUOTE

		}
	};
	show_block_terminos(){
        this.quote.acepto_adicional = true;
        var total_asegurado = parseFloat(this.quote.total_asegurado) //.replaceAll(',', ''))

		const Compania = ['GNP USD', 'GNP MXN', 'CHUBB USD', 'CHUBB MXN', 'HDI', 'CHUBB GLOBAL', 'CHUBB INTERNACIONAL'];

		if (Compania.includes(this.quote.compania.name) && this.quote.compania.name) {

			this.quote.acepto_adicional = false;

			if(this.quote.compania.name == 'GNP USD'){
				if (total_asegurado < 100000 ){
					this.quote.acepto_adicional_type = '1'
				}else{
					this.quote.acepto_adicional_type = '2'
				}
			}
			if(this.quote.compania.name == "GNP MXN"){
				if (total_asegurado < 2000000 ){
					this.quote.acepto_adicional_type = '1'
				}else{
					this.quote.acepto_adicional_type = '2'
				}
			}

            if(this.quote.compania.name == 'CHUBB USD'){
                if (total_asegurado < 100000 ){
                    this.quote.acepto_adicional_type = '3'
                }else{
                    this.quote.acepto_adicional_type = '4'
                }
            }
            if(this.quote.compania.name == "CHUBB MXN"){
                if (total_asegurado < 2000000 ){
                    this.quote.acepto_adicional_type = '3'
                }else{
                    this.quote.acepto_adicional_type = '4'
                }
            }
			if (this.quote.compania.name == "HDI") {
				// establecer el check de acepto adicional al base
				// si no estan disponibles los datos de tipo de mercancia y transporte
				let tipoMercancia = this.quote.tipo_mercancia; // tipo de mercancia seleccionada (mercancia general, mercancia sensible diversa, mercancia sensible electronicos y maquinaria)
				let transporte = this.quote.transporte; // tipo de transporte seleccionado (maritimo, aereo, terrestre)

				if (!(tipoMercancia && transporte)) {
					this.quote.acepto_adicional_type = '5';
				} else {
					if (transporte.name == 'Terrestre') {
						if (tipoMercancia.name == 'Mercancía general') {
							if (total_asegurado >= 1 && total_asegurado <= 150000) {
								this.quote.acepto_adicional_type = '5'
							}
							if (total_asegurado > 150000 && total_asegurado <= 300000) {
								this.quote.acepto_adicional_type = '6'
							}
							if (total_asegurado > 300000) {
								this.quote.acepto_adicional_type = '7'
							}
						}
						if (tipoMercancia.name == 'Mercancía sensible diversa') { // modificacion de nombre de mercancia
							if (total_asegurado >= 1 && total_asegurado <= 150000) {
								this.quote.acepto_adicional_type = '6'
							}
							if (total_asegurado > 150000) {
								this.quote.acepto_adicional_type = '8'
							}
						}
						if (tipoMercancia.name == 'Mercancía sensible electrónicos') { // modificacion de nombre de mercancia
							this.quote.acepto_adicional_type = '8'
						}
						if (tipoMercancia.name == 'Maquinaria') { // modificacion de nombre de mercancia
							if (total_asegurado >= 1 && total_asegurado <= 150000) {
								this.quote.acepto_adicional_type = '5'
							}
							if (total_asegurado > 150000) {
								this.quote.acepto_adicional_type = '6'
							}
						}
					} else {
						this.quote.acepto_adicional_type = '5'
					}
				}
			}
			if(this.quote.compania.name == 'CHUBB GLOBAL') { // actualizacion para CHUBB GLOBAL (validar si es correcto)
                if (total_asegurado < 100000) {
                    this.quote.acepto_adicional_type = '3'
                } else {
                    this.quote.acepto_adicional_type = '4'
                }
            }
			if (this.quote.compania.name == 'CHUBB INTERNACIONAL') { // actualizacion para CHUBB INTERNACIONAL (validar si es correcto)
				if (total_asegurado < 100000) {
					this.quote.acepto_adicional_type = '3'
				} else {
					this.quote.acepto_adicional_type = '4'
				}
			}
        }

    };

	changeCompany(item) {
	    //debugger;
		this.servicesId = item.id;
		this._commodity_list = [];
		this.quote.cobertura_list = [];
		this.quote.tipo_mercancia = '';
		this.quote.cobertura = '';
		this.quote.contenedores = [];
		this.containers = [];
		this.quote.cobertura_contenedor == false;
		let name = (item.name).toLowerCase();
		this.acepto_adicional = true;
        console.log('categories.certificado ', this.categories.certificado, 'item.name', item.name)
        this.show_block_terminos();

		if (name == 'jah'){
			this.JAH_ID = item.id;
			this.id_company = item.id;
			this.quote.currency_total = 'usd';
			this.quote.valor_type = 'usd';
			this.quote.flete_type = 'usd';
			this.quote.impuestos_type = 'usd';
			this.quote.operacion_type = 'usd';

			// console.log(this._commodity_list);
			if (!this.jah_commodities) {

				this.getJahCommodities.emit('ok');
			}
		}

		else if (name == 'chubb usd' || name == 'gnp usd' || name == 'hdi' || name == 'chubb global' || name == 'chubb internacional') {

			this.quote.currency_total = 'usd';
			this.quote.valor_type = 'usd';
			this.quote.flete_type = 'usd';
			this.quote.impuestos_type = 'usd';
			this.quote.operacion_type = 'usd';

			// console.log(this._commodity_list);
			// this.quote.tipo_mercancia = this._commodity_list[0];
			// this.selectCommodity(this.quote.tipo_mercancia);

		} else {

			this.quote.currency_total = 'mxn';
			this.quote.valor_type = 'mxn';
			this.quote.flete_type = 'mxn';
			this.quote.impuestos_type = 'mxn';
			this.quote.operacion_type = 'mxn';

			// demás aseguradoras.

			// commodities
		}

		let data = {
			grupo: this.cliente_seleccionado.id,
			service: item.id
		}

		if(name == 'gnp mxn' || name == 'chubb mxn'){
			this.leyenda_seguridad = "En transporte terrestre a partir de $2,500,001.00 MXN o su equivalente en moneda extranjera, se requiere de GPS + custodia física y/o virtual obligada (Aplica para multimodal con servicio terrestre)";
		}else if(name == 'gnp usd'){
			this.leyenda_seguridad = "En transporte terrestre a partir de $2,500,001.00 MXN o su equivalente en moneda extranjera, se requiere de GPS + custodia física y/o virtual obligada (Aplica para multimodal con servicio terrestre)";
		}else if(name == 'chubb usd'){
			this.leyenda_seguridad = " En transporte terrestre a partir de $100,000.00 USD, se requiere de GPS + custodia física y/o virtual obligada (Aplica para multimodal con servicio terrestre)";
		}else if(name == 'jah'){
			this.leyenda_seguridad = "En transporte terrestre a partir de $100,001.00 USD o su equivalente en otra moneda, se requiere de GPS + custodia física y/o virtual obligada (Aplica para multimodal con servicio terrestre)";
		} else if (name == 'hdi') { // actualizacion para HDI
			// leyenda base
			this.leyenda_seguridad = "En transporte terrestre a partir de $300,000.00 USD o su equivalente en otra moneda, se requiere de GPS + custodia física obligada (Aplica para multimodal con servicio terrestre) excepto para embarques de maquinaria.";
		} else if (name == 'chubb global') { // actualizacion para CHUBB GLOBAL
			// leyenda base
			this.leyenda_seguridad = "En transporte terrestre a partir de $100,000.00 USD o su equivalente en otra moneda, se requiere de GPS + custodia física y/o virtual obligada (Aplica para multimodal con servicio terrestre)";
		} else if (name == 'chubb internacional') { // actualizacion para CHUBB INTERNACIONAL
			// leyenda base
			this.leyenda_seguridad = "En transporte terrestre a partir de $100,000.00 USD o su equivalente en otra moneda, se requiere de GPS + custodia física y/o virtual obligada (Aplica para multimodal con servicio terrestre)";
		}
		// console.log('data', data);
		this.getCommonCom.emit(data);

	};

	changeCoberage() {
		if (this.quote.compania.name == 'JAH') {
			if (this.quote.cobertura.name == 'FULL COVER PLUS') {
				this.quote.rc_errores_omisiones = true;
				this.coberage_full = true;
			} else {
				this.quote.rc_errores_omisiones = false;
				this.coberage_full = false;
			}
		} else {
			this.quote.rc_errores_omisiones = false;
			this.coberage_full = false;
		}

		this.quote.transporte = '';
	}

	default_country = '';

	changeTypeOperation() {
		switch (this.quote.tipo_operacion) {
			case "transporte_internacional":
				this.quote.transporte_nacional = false;
				this.quote.importacion = false;
				this.quote.exportacion = false;
				this.quote.origen_pais = '';
				this.quote.destino_pais = '';
				// this.quote.destino_pais = this.countries[84];

				this.quote.origen_codigo_postal = '';
				this.quote.origen_ciudad = '';
				this.quote.origen_colonia = '';
				this.quote.origen_calle = '';
				this.quote.origen_numero = '';

				this.quote.destino_codigo_postal = '';
				this.quote.destino_ciudad = '';
				this.quote.destino_colonia = '';
				this.quote.destino_calle = '';
				this.quote.destino_numero = '';

				break;
			case "transporte_nacional":
				this.quote.transporte_nacional = true;
				this.quote.importacion = false;
				this.quote.exportacion = false;
				this.quote.origen_pais = this.countries[84];
				this.quote.destino_pais = this.countries[84];
				this.quote.origen_ciudad = '';
				this.quote.origen_colonia = '';
				this.quote.destino_ciudad = '';
				this.quote.origen_codigo_postal = '';
				this.quote.destino_colonia = '';
				this.quote.destino_codigo_postal = '';
				// this.default_country = this.countries[84];

				break;
			case "importacion":
				this.quote.transporte_nacional = false;
				this.quote.importacion = true;
				this.quote.exportacion = false;
				this.quote.origen_pais = '';
				// this.quote.destino_pais = '';
				this.quote.destino_pais = this.countries[84];

				this.quote.origen_codigo_postal = '';
				this.quote.origen_ciudad = '';
				this.quote.origen_colonia = '';
				this.quote.origen_calle = '';
				this.quote.origen_numero = '';

				this.quote.destino_codigo_postal = '';
				this.quote.destino_ciudad = '';
				this.quote.destino_colonia = '';
				this.quote.destino_calle = '';
				this.quote.destino_numero = '';

				break;
			case "exportacion":
				this.quote.transporte_nacional = false;
				this.quote.importacion = false;
				this.quote.exportacion = true;
				// this.quote.origen_pais = '';
				this.quote.origen_pais = this.countries[84];
				this.quote.destino_pais = '';
				this.quote.origen_codigo_postal = '';
				this.quote.origen_ciudad = '';
				this.quote.origen_colonia = '';
				this.quote.origen_calle = '';
				this.quote.origen_numero = '';

				this.quote.destino_codigo_postal = '';
				this.quote.destino_ciudad = '';
				this.quote.destino_colonia = '';
				this.quote.destino_calle = '';
				this.quote.destino_numero = '';
				break;
			default:
				break;
		}
		if(localStorage.duplicate){
			let address_from = this.quote_load.desde.address.split(',');
			let address_to = this.quote_load.hasta.address.split(',');

			this.quote_load = JSON.parse(localStorage.contractor_selected);
			for (let i in this.countries){
				if(this.countries[i].country == this.quote_load.desde.id){
					this.quote.origen_pais = this.countries[i];
					if (i!='84'){
						this.quote.origen_colonia = address_from[1].trim();
					}
				}
				if(this.countries[i].country == this.quote_load.hasta.id){
					this.quote.destino_pais = this.countries[i];
					if (i!='84'){
						this.quote.origen_colonia =  address_to[1].trim();
					}

				}
			}
			if ('details' in this.quote_load.desde){
				this.quote.origen_codigo_postal = this.quote_load.desde.details.zipcode;
				this.col_by_zip_desde(this.quote.origen_codigo_postal);
				this.quote.origen_ciudad = this.quote_load.desde.city;
				this.quote.origen_calle = this.quote_load.desde.details.street;
				this.quote.origen_numero = this.quote_load.desde.details.number;

			}else {
				this.quote.origen_codigo_postal = address_from[address_from.length-1].trim();
				this.col_by_zip_desde(this.quote.origen_codigo_postal);
				this.quote.origen_ciudad = this.quote_load.desde.city;
				this.quote.origen_calle = address_from[0].replace(address_from[0].match(/\d+/),'');
				this.quote.origen_numero = address_from[0].match(/\d+/);
			}
			if ('details' in this.quote_load.hasta){
				this.quote.destino_codigo_postal = this.quote_load.hasta.details.zipcode;
				this.col_by_zip_hasta(this.quote.destino_codigo_postal);
				this.quote.destino_ciudad = this.quote_load.hasta.city;
				this.quote.destino_numero = this.quote_load.hasta.details.number;
				this.quote.destino_calle = this.quote_load.hasta.details.street

			}else{
				this.quote.destino_codigo_postal = address_to[address_from.length-1].trim();
				this.col_by_zip_hasta(this.quote.destino_codigo_postal);
				this.quote.destino_ciudad = this.quote_load.hasta.city;
				this.quote.destino_numero = address_to[0].match(/\d+/);
				this.quote.destino_calle = address_to[0].replace(address_to[0].match(/\d+/), "")
			}
		}
	};

	selectReference() {
		if (this.quote.numero_pedimento_referencia || this.quote.numero_sello) {
			this.reference = true;
		} else {
			this.reference = false;
		}
	}

	selectTransportRef() {

		if (this.quote.documento || this.quote.buque) {
			this.reference_transport = true;
		} else {
			this.reference_transport = false;
		}
	}


	addContainer() {
		this.showModalContainer = true;
		this.value_disabled = false;
		for(var i = 0; i < this._containers_list.length; i++){
			if(this._containers_list[i].serie != undefined){
				this._containers_list[i].serie = "";
			}
		}
	};

	cancelContainer() {
		this.showModalContainer = false;
		this.container = [];
	};

	closeContainer() {
		this.showModalContainer = false;
		// this.container = '';
		// this.container.value = '';
		// this.container.serial = '';
		this.copy = JSON.parse(JSON.stringify(this.containers));

		if (this.quote.cobertura.name == 'FULL COVER PLUS') {
			for (var i = 0; i < this.copy.length; ++i) {
				if (this.copy[i].container == 1 || this.copy[i].container == 2 || this.copy[i].container == 3) {
					this.free_container = true;
					this.free = this.copy[i];
					break;
				}
			}
		}

		if (this.free_container) {
			this.quote.prima_contenedor = parseFloat(this.quote.prima_contenedor) - parseFloat(this.free['premium']['1']);
		}
		this.container = [];
	};

	changeTypeContainer(item) {
		this.value_disabled = true;
	};

	deleteContainer(idx, item) {
		this.copy.splice(idx, 1);
		this.quote.prima_contenedor = 0;
		if (this.free) {
			if (item.serie == this.free['serie']) {
				this.free_container = false;
				this.free = [];
			}
		}

		for (var i = 0; i < this.copy.length; ++i) {
			this.quote.prima_contenedor = parseFloat(this.quote.prima_contenedor) + parseFloat(this.copy[i].premium['1']);
		}
		if (this.quote.cobertura.name == 'FULL COVER PLUS') {
			for (var i = 0; i < this.copy.length; ++i) {
				if (this.copy[i].container == 1 || this.copy[i].container == 2 || this.copy[i].container == 3) {
					this.free_container = true;
					this.free = this.copy[i];
					break;
				}
			}
		}
		if (this.free_container) {
			this.quote.prima_contenedor = parseFloat(this.quote.prima_contenedor) - parseFloat(this.free['premium']['1']);
		}

		this.changeTotalPrima();
		this.container = [];
	};

	saveContainer(item) {
		this.containers = this.copy;
		this.containers.push(item);

		this.quote.prima_contenedor = 0;

		for (var i = 0; i < this.containers.length; ++i) {
			this.quote.prima_contenedor = parseFloat(this.quote.prima_contenedor) + parseFloat(this.containers[i].premium['1']);
		}
		// if (this.free_container) {
		// 	this.quote.prima_contenedor = parseFloat(this.quote.prima_contenedor) - parseFloat(this.free['premium']['1']);
		// }

		this.closeContainer();
		this.changeTotalPrima();
		// this.container.serie = "";
		this.container = [];
	};

	parseDate(parDate) {

		let date = parDate.split('/');
		let format_date = new Date(date[2], date[1], date[0]);

		return format_date;
	};

	onAmountChange(param, event, backspace) {

		let characterInput = event.data;

		let value = String(this.quote[param]);

		value = value.replace(/,/g, "")
		value = value.replace(/[a-zA-Z]/g, "")

		let first_value;
		let decimals;
		let newVal;

		let data = value.split('.');

		if (data.length == 2) {
			first_value = data[0];
			decimals = data[1];
		} else {
			first_value = data[0];
			decimals = '';
		}

		if (first_value.length < 4) {
			first_value = first_value.replace(/^(\d{0,3})/, '$1');
		} else if (first_value.length == 4) {
			first_value = first_value.replace(/^(\d{0,1})(\d{0,3})/, '$1,$2');
		} else if (first_value.length == 5) {
			first_value = first_value.replace(/^(\d{0,2})(\d{0,3})/, '$1,$2');
		} else if (first_value.length == 6) {
			first_value = first_value.replace(/^(\d{0,3})(\d{0,3})/, '$1,$2');
		} else if (first_value.length == 7) {
			first_value = first_value.replace(/^(\d{0,1})(\d{0,3})(\d{0,3})/, '$1,$2,$3');
		} else if (first_value.length == 8) {
			first_value = first_value.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})/, '$1,$2,$3');
		} else if (first_value.length == 9) {
			first_value = first_value.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3');
		} else if (first_value.length == 10) {
			first_value = first_value.replace(/^(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3,$4');
		} else if (first_value.length == 11) {
			first_value = first_value.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3,$4');
		} else if (first_value.length == 12) {
			first_value = first_value.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3,$4');
		} else if (first_value.length == 13) {
			first_value = first_value.replace(/^(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3,$4,$5');
		} else if (first_value.length == 14) {
			first_value = first_value.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3,$4,$5');
		} else if (first_value.length == 15) {
			first_value = first_value.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3,$4,$5');
		} else if (first_value.length == 16) {
			first_value = first_value.replace(/^(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3,$4,$5');
		} else if (first_value.length == 17) {
			first_value = first_value.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3,$4,$5');
			// exeded = true;
			// newVal = first_value + '.00';
			// this.data.valor_carga = first_value;
			// return;
		} else if (first_value.length == 18) {
			first_value = first_value.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, '$1,$2,$3,$4,$5');
			// exeded = true;
			// newVal = first_value + '.00';
			// this.data.valor_carga = first_value;
			// return;
		}

		if (decimals !== '') {
			newVal = first_value + '.' + decimals;
		} else {
			newVal = first_value;
		}

		this.quote[param] = newVal;
	};

	formatearValor(param: any, event: any) {
		if (event != '') {
			let valor = event.split('.');
			if (valor.length >= 2) {
				if (valor[1] === '') {
					valor[1] = '0';
				} else {
					valor[1] = valor[1].substring(0, 2);
				}
				this.quote[param] = valor[0] + '.' + valor[1];
			}
		} else {
			this.quote[param] = '0';
		}

	}

	next_of_product(value) {
	    //console.log("next_of_product", value )

		// console.log('aaa', this.jah_transport_type);
		if (value == 1) {
			if(this.admin){
				this.categories.metodo = false;
				this.categories.contratante = true;
			} else {
				this.categories.metodo = false;
				this.categories.cliente = true;
			}
		} else if (value == 2) {
			this.categories.contratante = false;
			this.categories.cliente = true;
			this.insuredAction(2);
		} else if (value == 3) {
			this.quote.importacion_desde = null;
			this.quote.importacion_hasta = null;
			this.categories.mercancia = false;
			this.categories.transporte = true;
			if(localStorage.duplicate){
				this.quote_load = JSON.parse(localStorage.contractor_selected);
				if (this.quote_load.quote_type==1){
					if(this.quote_load.desde.id == 86 && this.quote_load.hasta.id == 86){
						this.quote.tipo_operacion = "transporte_nacional";
					} else if(this.quote_load.desde.id == 86 && this.quote_load.hasta.id != 86){
						this.quote.tipo_operacion = "exportacion";

					} else if(this.quote_load.desde.id != 86 && this.quote_load.hasta.id == 86){
						this.quote.tipo_operacion = "importacion";
					}
					this.changeTypeOperation()
				}
			}
			console.log("next_of_product this.quote.compania.name: ", this.quote.compania.name)
			console.log("tarifa: ", this.quote.cobertura.is_active_tarifa, this.quote.cobertura.tarifa)
			console.log("tasa_venta: ", this.quote.cobertura.is_active_tasa_venta, this.quote.cobertura.tasa_venta)
			if (!this.tasa_venta_modificada && this.quote.tipo_mercancia.name !== this.enumContenedor.Contenedor) { // validacion contenedor
				if (this.quote.compania.name !== 'jah'){
					if(this.quote.cobertura.is_active_tarifa === true){
						this.quote.tasa_prima = this.quote.cobertura.tarifa
					}
					if(this.quote.cobertura.is_active_tasa_venta === true){
						this.quote.tasa_prima = this.quote.cobertura.tasa_venta
					}
				}
			}
			
			// llamar changeTotalPrima si no es tipo contenedor
			if (this.quote.tipo_mercancia.name !== this.enumContenedor.Contenedor) {
				this.changeTotalPrima();
			}
			// console.log(this['jah_transport_type']);
		} else if (value == 4) {
			if (localStorage.duplicate){
				this.quote_load = JSON.parse(localStorage.contractor_selected)
				this.quote.operacion = this.quote_load.gastos_operacionales;
				this.quote.tasa_prima = !this.tasa_venta_modificada ? this.quote_load.tasa+'%' : this.quote.tasa_prima;
				this.calculateSubtotalUltimate()
				console.log(this.quote.tasa_prima)
			}
			// transporte

			// if(this.quote.tipo_empaque) {

			// } else {
			// 	swal.fire({
			// 	  title: '¡Importante!',
			// 	  text: 'Si no tiene tipo de empaque, favor de ingresar "SIN EMPAQUE" o "A GRANEL"',
			// 	  type: 'warning',
			// 	  showCancelButton: false,
			// 	  confirmButtonColor: '#3085d6',
			// 	  // cancelButtonColor: '#d33',
			// 	  confirmButtonText: 'Aceptar'
			// 	});
			// 	return;
			// }

			if(this.quote.cobertura.cover == 1) {
				this.quote.rc_errores_omisiones = false;
				this.coberage_full = true;
			}
			else if(this.quote.cobertura.cover == 2) {
				this.quote.rc_errores_omisiones = false;
				this.coberage_full = true;

			}
			else if(this.quote.cobertura.cover == 3) {
				this.quote.rc_errores_omisiones = true;
				this.coberage_full = true;

			}


			this.categories.transporte = false;
			this.categories.valor = true;
			if (!localStorage.duplicate){
				this.quote.tasa_prima = !this.tasa_venta_modificada && this.quote.tipo_mercancia.name !== this.enumContenedor.Contenedor ? (this.quote.cobertura.tarifa) + '%' : this.quote.tasa_prima; // validacion contenedor
			}

			if(this.metodo_quote == 'Documental'){
				this.categories.mercancia = false;
			}

			console.log("next_of_product this.quote.compania.name: ", this.quote.compania.name)
			console.log("tarifa: ", this.quote.cobertura.is_active_tarifa, this.quote.cobertura.tarifa)
			console.log("tasa_venta: ", this.quote.cobertura.is_active_tasa_venta, this.quote.cobertura.tasa_venta)
			if (this.quote.compania.name !== 'jah' && this.quote.tipo_mercancia.name !== this.enumContenedor.Contenedor){ // validacion contenedor
			    if(this.quote.cobertura.is_active_tarifa === true){
		            this.quote.tasa_prima = !this.tasa_venta_modificada ? this.quote.cobertura.tarifa : this.quote.tasa_prima;
		        }
		        if(this.quote.cobertura.is_active_tasa_venta === true){
		            this.quote.tasa_prima = !this.tasa_venta_modificada ? this.quote.cobertura.tasa_venta : this.quote.tasa_prima;
		        }
		    }

			// llamar changeTotalPrima si no es tipo contenedor
			if (this.quote.tipo_mercancia.name !== this.enumContenedor.Contenedor) {
				this.changeTotalPrima();
			}

		} else if (value == 5) {
			this.categories.valor = false;
			if (localStorage.insured_selected) {
				localStorage.removeItem('insured_selected');
			}
			// this.categories.certificado = true;
			if(this.metodo_quote == 'Documental'){
				this.sendCertificateDocumental();
			}else{
				this.sendCertificate();
			}

		} else if (value == 6) {
			this.categories.certificado = false;
			// 		this.client_data = null;
			// 		this.quote = {
			// 	compania: null,
			// 	transporte: null,
			// 	tipo_mercancia: null,
			// 	cobertura: null,
			// 	descripcion_mercancia: null,
			// 	numero_pedimento_referencia: null,
			// 	numero_sello: null,
			// 	compania_transportadora: null,
			// 	documento: null,
			// 	buque: null,
			// 	do: null,
			//        operador: null,
			// 	tipo_embalaje: null,
			// 	medidas_seguridad: null,
			//        transporte_nacional: false,
			//        importacion: false,
			//        exportacion: false,
			//        importacion_desde: '',
			//        importacion_hasta: '',
			// 	origen_pais: null,
			// 	origen_ciudad: null,
			// 	origen_calle: null,
			// 	origen_numero: null,
			// 	origen_colonia: null,
			// 	origen_codigo_postal: null,
			// 	destino_pais: null,
			// 	destino_ciudad: null,
			// 	destino_calle: null,
			// 	destino_numero: null,
			// 	destino_colonia: null,
			// 	destino_codigo_postal: null,
			// 	trayecto: null,
			// 	valor_mercancia: 0,
			// 	flete: 0,
			//        impuestos_nacionales: 0,
			//        subtotal: 0,
			//        gastos_adicionales: false,
			//        total: 0,
			// 	cobertura_contenedor: false,
			// 	rc_errores_omisiones: false,
			// 	tasa_prima: 0,
			// 	prima: 0,
			// 	prima_eo: 0,
			// 	prima_contenedor: 0,
			// 	total_prima: 0,
			//        observaciones: null,
			// };
			// this.containers = [];
			// this.container = [];
		} else if (value == 7){
			this.categories.contratante = false;
			this.categories.metodo = true;
			this.proceso_documental = false;
		} else if (value == 8){
			this.quote.importacion_desde = null;
			this.quote.importacion_hasta = null;
			if (this.data_services){
				for(var i=0; i < this.data_services.length; i++){
					if(this.data_services[i].name.indexOf('JAH') != -1){
					this.data_services.splice(i, 1);
					}
				}
			}
			this.categories.cliente = false;
			this.categories.mercancia = true;
			if(localStorage.duplicate){

				this.quote_load = JSON.parse(localStorage.contractor_selected)
				for (let i in this.countries){
					if(this.countries[i].country == this.quote_load.desde.id){
						this.quote.origen_pais = this.countries[i];
						this.quote.origen_ciudad = this.quote_load.desde.city;
					}
					if(this.countries[i].country == this.quote_load.hasta.id){
						this.quote.destino_pais = this.countries[i];
						this.quote.destino_ciudad = this.quote_load.hasta.city;

					}

				}
				if(this.quote_load.quote_type ==2){
					localStorage.removeItem('duplicate');
				}
			} else
			if(this.metodo_quote=='Documental'){
				this.quote.origen_pais = !this.pais_origen_modificado ? this.countries[84] : this.quote.origen_pais;
				this.quote.destino_pais = !this.pais_destino_modificado ? this.countries[84] : this.quote.destino_pais;
			}
		}else if (value == 9) {
			this.categories.valor = false;
			// this.categories.certificado = true;
			this.clear_form =true;
			if(this.metodo_quote == 'Documental'){
				this.sendCertificateDocumental();
			}else{
				this.sendCertificate();
			}

		}
	}

	calculateSubtotal2(parAttr, parVal) {

		let subtotal = 0;
		let valor_mecancia = (this.quote.valor_mercancia).replace(/,/g, "");
		let flete = 0;
		let impuestos = 0;
		let lucro_cesante = 0;

		if (this.quote.flete) {
			flete = (this.quote.flete).replace(/,/g, "");
		}

		if (this.quote.impuestos_nacionales) {
			impuestos = (this.quote.impuestos_nacionales).replace(/,/g, "");
		}

		if (this.quote.lucro_cesante) {
			lucro_cesante = (this.quote.lucro_cesante).replace(/,/g, "");
		}

		let valor_ = valor_mecancia ? valor_mecancia : 0;
		let valor_cambio = this.quote.valor_type ? this.quote.valor_type : 1;

		// console.log('valor_mercancia', valor_);
		// console.log('valor_cambio');

		valor_ = valor_ * valor_cambio;

		let flete_ = flete ? flete : 0;
		let flete_cambio = this.quote.flete_type ? this.quote.flete_type : 1;
		flete_ = flete_ * flete_cambio;

		let impuestos_ = impuestos ? impuestos : 0;
		let impuestos_cambio = this.quote.impuestos_type ? this.quote.impuestos_type : 1;
		impuestos_ = impuestos_ * impuestos_cambio;

		let lucro_cesante_ = lucro_cesante ? lucro_cesante : 0;
		let lucro_cesante_cambio = this.quote.valor_type ? this.quote.valor_type : 1;
		lucro_cesante_ = lucro_cesante_ * lucro_cesante_cambio;

		let subtotal_pesos = (valor_) + (flete_) + (impuestos_) + (lucro_cesante_);
		let subtotal_dolars = parseFloat(subtotal_pesos) / this.valores_moneda.usd;

		if (this.quote.compania == 1) {
			subtotal = subtotal_dolars;

		} else {
			subtotal = subtotal_pesos;
		}

		if (parAttr == 1) {
			this.quote.valor_mercancia_exchange = parVal;
		} else if (parAttr == 2) {
			this.quote.flete_exchange = parVal;
		} else if (parAttr == 3) {
			this.quote.impuestos_nacionales_exchange = parVal;
		}


		this.quote.subtotal = (subtotal).toFixed(2);

		// if(this.quote.gastos_adicionales) {
		// this.gastos_adicionales = subtotal * 0.10;
		// console.log(this.gastos_adicionales);

		// this.gastos_adicionales = parseFloat(this.gastos_adicionales).toFixed(2);

		// 	this.quote.total = subtotal * 1.10;
		// 	this.quote.total = (this.quote.total).toFixed(2);

		// } else {
		// 	this.gastos_adicionales = 0;
		// 	this.quote.total = (subtotal).toFixed(2);
		// 	this.quote.total = parseFloat(this.quote.total).toFixed(2);
		// }
	};

	validateMin() {

		var total_asegurado_ = (this.quote.total_asegurado).replace(/,/g, '')
		var total_currency = parseFloat(total_asegurado_);


		if (this.quote.compania.name == 'JAH') {
			if (total_currency < 600.00) {
				alert('La tarifa minima es de 60 dolares.');
				// Verificar conversion de dolares y pesos
				// this.quote.total_asegurado = 60.00;
				this.quote.total_asegurado = 60.00;
			}
		} else {
			// console.log('total_asegurado',(total_currency));

			if (total_currency < 500.00) {
				alert('La tarifa minima es de 500 pesos mexicanos.');
				this.quote.total_asegurado = 500.00;
			}
		}

		this.changeTotalPrima();


	}

	validateSecurity() {

		// let _v_mercancia = parseFloat((this.quote.valor_mercancia).replace(/,/g, ''));

		let _v_mercancia = (this.convertCurrency(this.quote.valor_mercancia, this.quote.valor_type)).toFixed(2);
		let mercancia = parseFloat(_v_mercancia);

		// Las alertas de GNP y CHUBB se remueven

		if(this.quote.compania.name == 'JAH') {

			_v_mercancia =  (mercancia / this.rate_exchange_usd).toFixed(2);
			// console.log('_v_mercancia', _v_mercancia);
			// console.log('aaa----------', parseFloat(_v_mercancia) * 0.10);

			const TRANSPORTES_VALIDOS = ['Terrestre', 'Multimodal'];

			if (TRANSPORTES_VALIDOS.includes(this.quote.transporte.name)) {

				// cheacar que onda con los dolares
				if (mercancia > 1 && mercancia <= 100000) {

					alert('Dentro de México se requiere cumplir con los requisitos de seguridad indicados: GPS');

				}
				if (mercancia > 100000 && mercancia <= 150000) {

					alert('Dentro de México se requiere cumplir con los requisitos de seguridad indicados: GPS + Custodia Virtual');

				}
				if (mercancia >= 150001) {

					alert('Dentro de México se requiere cumplir con los requisitos de seguridad indicados: GPS + Custodia Física');
				}
			}
		}

		if (this.quote.compania.name == 'HDI') {
			//checar que esta cantidad sea en MXN
			if (mercancia > 1000000 && this.quote.transporte.name == "Terrestre") {
				// alert_message = 'Dentro de México se requiere cumplir con los requisitos de seguridad indicados: GPS + Custodia Virtual + Custodia Física';
				alert('Dentro de México se requiere cumplir con los requisitos de seguridad indicados: Custodia Física');
			}

		}
	}

	calculateSubtotalUltimate(param=null) {
		if (this.gas_add == 'si') {
			this.quote.gastos_adicionales = true;
		} else {
			this.quote.gastos_adicionales = false;
			$("#g_add").trigger('click');
		}
        if(param!='valor_mercancia' || this.quote.valor_mercancia!=''){
			this.quote.valor_mercancia = this.quote.valor_mercancia ? this.quote.valor_mercancia : 0;
        }
       	if(param!='flete' || this.quote.flete!=''){
			this.quote.flete = this.quote.flete ? this.quote.flete : 0;
		}
       	if(param!='impuestos_nacionales' || this.quote.impuestos_nacionales!=''){
			this.quote.impuestos_nacionales = this.quote.impuestos_nacionales ? this.quote.impuestos_nacionales : 0;
       	}
		if (param != 'lucro_cesante' || this.quote.lucro_cesante != '') {
			this.quote.lucro_cesante = this.quote.lucro_cesante ? this.quote.lucro_cesante : 0;
		}
       	if(param!='operacion' || this.quote.operacion!=''){
			this.quote.operacion = this.quote.operacion ? this.quote.operacion : 0;
       	}

		this.valor_mecancia = this.convertCurrency(this.quote.valor_mercancia, this.quote.valor_type);
		if (this.quote.valor_mercancia.length > 2) {
			let min_valor_marcancia = 60;
			if (this.quote.compania == 1 && this.valor_mecancia < min_valor_marcancia) {
				this.quote.valor_mercancia = 60;
				this.valor_mecancia = min_valor_marcancia;
				alert("En JAH la prima mínima de venta debe ser $60dlls.");
			}
		}
		this.valor_flete = this.convertCurrency(this.quote.flete, this.quote.flete_type);
		if (this.valor_flete > (this.valor_mecancia * 0.6)) {
			this.quote.flete = 0;
			this.valor_flete = 0;
			alert("El flete no puede superar el 60% del valor de la factura.");
		}
		this.valor_impuestos = this.convertCurrency(this.quote.impuestos_nacionales, this.quote.impuestos_type);
		if (this.valor_impuestos > this.valor_mecancia) {
			this.quote.impuestos_nacionales = 0;
			this.valor_impuestos = 0;
			alert("El impuesto nacional no puede superar el valor de la factura.");
		}
		let lucro_cesante_valor = this.convertCurrency(this.quote.lucro_cesante, this.quote.valor_type);
		this.valor_operacion = this.convertCurrency(this.quote.operacion, this.quote.operacion_type);

		if (this.quote.compania.name != 'JAH') {
			if (this.valor_operacion > (this.valor_mecancia * 0.20)) {
				this.quote.operacion = 0;
				this.valor_operacion = 0;
				alert("Los gastos operacionales no pueden superar el 20% sobre el valor de la factura.");
			}
		} else if (this.quote.compania.name == 'JAH') {
			if (this.valor_operacion > (this.valor_mecancia * 0.1)) {
				this.quote.operacion = 0;
				this.valor_operacion = 0;
				alert("Los gastos operacionales no pueden superar el 10% sobre el valor de la factura.");
			}
		}
		if(!this.valor_flete){this.valor_flete=0}
		if(!this.valor_impuestos){this.valor_impuestos=0}
		if(!this.valor_operacion){this.valor_operacion=0}
		if(!lucro_cesante_valor){lucro_cesante_valor=0}
		this.quote.subtotal = (this.valor_mecancia + this.valor_flete + this.valor_impuestos + lucro_cesante_valor).toFixed(2);
		this.quote.total_asegurado = (parseFloat(this.quote.subtotal) + this.valor_operacion).toFixed(2);




		this.quote.result_subtotal_peso = this.quote.subtotal;
		if (this.quote.currency_total == 'usd'){
			this.quote.result_subtotal_peso = (this.quote.result_subtotal_peso * this.rate_exchange_usd).toFixed(2);
		} else if(this.quote.currency_total == 'eur'){
			this.quote.result_subtotal_peso = (this.quote.result_subtotal_peso * this.rate_exchange_eur).toFixed(2);
		}
		this.quote.result_subtotal_dollar = (this.quote.subtotal / this.rate_exchange_usd).toFixed(2);
		if (this.quote.currency_total == 'mxn'){
			this.quote.result_total_dollar = (this.quote.result_subtotal_dollar / this.rate_exchange_usd).toFixed(2);
		} else if(this.quote.currency_total == 'eur'){
			this.quote.result_total_peso = ((this.quote.result_subtotal_dollar * this.rate_exchange_eur)/ this.rate_exchange_usd).toFixed(2);
		}

		if (this.quote.gastos_adicionales) {
			let _v_mercancia = (this.convertCurrency(this.quote.valor_mercancia, this.quote.valor_type)).toFixed(2);

			if(this.quote.compania.name == 'JAH') {

				let x  = (this.convertCurrency(this.quote.valor_mercancia, this.quote.valor_type)).toFixed(2);
				_v_mercancia =  (parseFloat(x) / this.rate_exchange_usd).toFixed(2);
			}

			this.gastos_adicionales = (parseFloat(_v_mercancia) * 0.1);
			this.quote.total_asegurado = (parseFloat(this.quote.total_asegurado) + (this.valor_mecancia * 0.1)).toFixed(2);
		}

		this.quote.result_total_peso = this.quote.total_asegurado;
		if (this.quote.currency_total == 'usd'){
			this.quote.result_total_peso = (this.quote.result_total_peso * this.rate_exchange_usd).toFixed(2);
		} else if(this.quote.currency_total == 'eur'){
			this.quote.result_total_peso = (this.quote.result_total_peso * this.rate_exchange_eur).toFixed(2);
		}
		this.quote.result_total_dollar = this.quote.total_asegurado
		if (this.quote.currency_total == 'mxn'){
			this.quote.result_total_dollar = (this.quote.result_total_dollar / this.rate_exchange_usd).toFixed(2);
		} else if(this.quote.currency_total == 'eur'){
			this.quote.result_total_peso = ((this.quote.result_total_dollar * this.rate_exchange_eur)/ this.rate_exchange_usd).toFixed(2);
		}
		console.log(this.quote.currency_total,this.quote.valor_type)
		/*if (this.quote.currency_total == 'usd' && this.quote.valor_type=='mxn' ) {
			this.quote.subtotal = (this.quote.subtotal / this.rate_exchange_usd).toFixed(2);
			this.quote.total_asegurado = (this.quote.total_asegurado / this.rate_exchange_usd).toFixed(2);
		}*/

		if (lucro_cesante_valor > (this.quote.total_asegurado * 0.2)) { // 20% del valor total
			this.quote.lucro_cesante = 0;
			lucro_cesante_valor = 0;
			alert("El lucro cesante no puede superar el 20% sobre el valor total asegurado.");
		}

		// console.log("this.limite_despacho", this.limite_despacho, "this.quote.total_asegurado", this.quote.total_asegurado)
		if (this.quote.total_asegurado > this.limite_despacho) {
			this.quote.valor_mercancia = 0;
			this.valor_mecancia = 0;
			alert("El total asegurado no puede superar el límite de despacho.");
			// console.log("this.limite_despacho: ",this.limite_despacho)
			this.quote.subtotal = (this.valor_mecancia + this.valor_flete + this.valor_impuestos + lucro_cesante_valor).toFixed(2);
			this.quote.total_asegurado = (parseFloat(this.quote.subtotal) + this.valor_operacion).toFixed(2);

			/*if (this.quote.currency_total == 'usd' && this.quote.valor_type=='mxn') {
				this.quote.subtotal = (this.quote.subtotal / this.rate_exchange_usd).toFixed(2);
				this.quote.total_asegurado = (this.quote.total_asegurado / this.rate_exchange_usd).toFixed(2);
			}*/
		}

		this.show_block_terminos();

		this.onAmountChange('subtotal', { 'data': this.quote.subtotal }, null);
		this.onAmountChange('total_asegurado', { 'data': this.quote.total_asegurado }, null);
		this.onAmountChange('result_total_peso', { 'data': this.quote.result_total_peso }, null);
		this.onAmountChange('result_total_dollar', { 'data': this.quote.result_total_dollar }, null);
		this.onAmountChange('result_subtotal_peso', { 'data': this.quote.result_subtotal_peso }, null);
		this.onAmountChange('result_subtotal_dollar', { 'data': this.quote.result_subtotal_dollar }, null);

		// this.changeTotalPrima();
	};

	calcularPrimaNeta() {
		let input = this.quote.prima;

		// remover caracteres no numericos excepto punto
		let valorSanitizado = input.replace(/[^0-9.]/g, '');

		// validar por multiples puntos y remover los extras
		if (valorSanitizado.split('.').length > 2) {
			const partes = valorSanitizado.split('.');
			valorSanitizado = partes[0] + '.' + partes.slice(1).join('');
		}

		// parsear el valor sanitizado a float (o a 0)
		valorSanitizado = parseFloat(valorSanitizado);

		// si prima venta no es un numero o esta vacio se asigna 0 como string
		if (isNaN(valorSanitizado) || valorSanitizado == '') {
			valorSanitizado = '0';
		}

		this.quote.prima = valorSanitizado.toString();
		this.quote.total_prima = valorSanitizado.toString();

	}

	aplicarDecimales() {
		let input = this.quote.prima;
		let inputTotalPrimas = this.quote.total_prima;

		// si prima venta no es un numero o esta vacio se asigna 0 como string
		if (isNaN(input) || input == '') {
			input = '0';
		}

		// si prima venta total no es un numero o esta vacio se asigna 0 como string
		if (isNaN(inputTotalPrimas) || inputTotalPrimas == '') {
			inputTotalPrimas = '0';
		}

		// redondear a 2 decimales prima venta
		input = parseFloat(input).toFixed(2);
		this.quote.prima = input;

		// redondear a 2 decimales prima venta total
		inputTotalPrimas = parseFloat(inputTotalPrimas).toFixed(2);
		this.quote.total_prima = inputTotalPrimas;

		// si los valores de prima venta y prima venta total son menor a la prima minima se pone una alerta de error y se regresa a la prima minima
		if (input < this.contenedorSelect.primaMinima || inputTotalPrimas < this.contenedorSelect.primaMinima) {
			alert('El valor de la prima no puede ser menor a $ ' + this.contenedorSelect.primaMinima.toFixed(2) + ' USD');
			this.quote.prima = this.contenedorSelect.primaMinima.toFixed(2);
			this.quote.total_prima = this.contenedorSelect.primaMinima.toFixed(2);
		}

		this.generarTasaVenta();

	}

	generarTasaVenta() {
		let primaNeta = parseFloat(this.quote.prima);
		let valorMercancia = parseFloat(this.quote.total_asegurado.replace(/,/g, ''));
		let tasaVenta = (primaNeta / valorMercancia) * 10000; // tasa_venta = (prima / monto_asegurado) * 10000

		// redondear a 2 decimales tasa venta
		tasaVenta = parseFloat(tasaVenta.toFixed(2));

		this.quote.tasa_prima = tasaVenta;
	}

	/**
	 * Si se modifica la tasa de venta se activa la bandera
	 */
	cambioTasaVenta() { this.tasa_venta_modificada = true; }

	/**
	 * Si se modifica el select del pais origen se activa la bandera
	 */
	cambioPaisOrigen() { this.pais_origen_modificado = true; }

	/**
	 * Si se modifica el select del pais destino se activa la bandera
	 */
	cambioPaisDestino() { this.pais_destino_modificado = true; }

	// siempre en pesos regresa
	convertCurrency(value, currency) {
		let value_int = String(value).replace(/,/g, "");
		let valor = 0;
		if (this.quote.compania.name != 'GNP USD' && this.quote.compania.name != 'CHUBB USD' && this.quote.compania.name != 'JAH' && this.quote.compania.name != 'HDI' && this.quote.compania.name != 'CHUBB GLOBAL' && this.quote.compania.name != 'CHUBB INTERNACIONAL') {
			if (currency == 'mxn') {
				valor = parseFloat(value_int) * this.rate_exchange_mxn;
			} else if (currency == 'usd') {
				valor = parseFloat(value_int) * this.rate_exchange_usd;
			} else if (currency == 'eur') {
				valor = parseFloat(value_int) * this.rate_exchange_eur;
			}
		}  else {
			if (currency == 'mxn') {
				valor = parseFloat(value_int) / this.rate_exchange_usd;
			} else if (currency == 'usd') {
				valor = parseFloat(value_int);
			} else if (currency == 'eur') {
				valor = (parseFloat(value_int) * this.rate_exchange_eur)/this.rate_exchange_usd;
			}
		}
		return valor;
	};

	changeCurrency(currency, currency_to, amount){
		currency = currency.toUpperCase();
		currency_to= currency_to.toUpperCase();
		if (currency=='MXN' && currency_to=='USD'){
			return amount/this.rate_exchange_usd;
		} else if (currency=='MXN' && currency_to=='EUR'){
			return amount/this.rate_exchange_eur;
		} else if (currency=='USD' && currency_to=='MXN'){
			return amount*this.rate_exchange_usd;
		}else if (currency=='USD' && currency_to=='EUR'){
			return (amount*this.rate_exchange_usd)/this.rate_exchange_eur;
		}else if (currency=='EUR' && currency_to=='MXN'){
			return (amount*this.rate_exchange_eur);
		}else if (currency=='EUR' && currency_to=='USD'){
			return (amount*this.rate_exchange_eur)/this.rate_exchange_usd;
		}

	}
	changeTotalPrima() {
		if (!this.quote.tasa_prima) { this.quote.tasa_prima = 0; }

		if (this.quote.tasa_prima == ".") { this.quote.tasa_prima = 0; }

		this.percent_value_ = true;
		let tasa_prima;
		let tasa_prima___ = this.quote.tasa_prima ? (this.quote.tasa_prima.toString()).replace('%', '') : 0;
		if (this.percent_value_) {
			// this.quote.tasa_prima = this.quote.tasa_prima / 100;
			tasa_prima = tasa_prima___ / 100;
		} else {
			// this.quote.tasa_prima = this.quote.cobertura.tarifa;
			tasa_prima = tasa_prima___;
		}

		tasa_prima = tasa_prima ? tasa_prima : parseFloat(String(this.quote.cobertura.value).replace(/%/g, ""));
		tasa_prima = tasa_prima ? tasa_prima : 0.2;

		if (this.quote.tasa_prima && this.quote.tasa_prima.toString().indexOf('%') > -1) {
			this.quote.tasa_prima = Number(String(this.quote.tasa_prima).replace(/%/g, ""));
		}

		if (this.quote.cobertura.tarifa && this.quote.cobertura.tarifa.toString().indexOf('%') > -1) {
			this.quote.cobertura.tarifa = Number(String(this.quote.cobertura.tarifa).replace(/%/g, ""));
		}

		if (this.quote.cobertura.tasa_venta && this.quote.cobertura.tasa_venta.toString().indexOf('%') > -1) {
			this.quote.cobertura.tasa_venta = Number(String(this.quote.cobertura.tasa_venta).replace(/%/g, ""));
		}

		if (this.quote.cobertura.prima_adquisicion && this.quote.cobertura.prima_adquisicion.toString().indexOf('%') > -1) {
			this.quote.cobertura.prima_adquisicion = Number(String(this.quote.cobertura.prima_adquisicion).replace(/%/g, ""));
		}

		// validar si la tasa de venta ha sido modificada para no sobreescribirla
		if (!this.tasa_venta_modificada) {
			let tarifa = Number(this.quote.cobertura.tarifa);
			let tasaVenta = Number(this.quote.cobertura.tasa_venta);
			let primaAdquisicion = Number(Number(this.quote.cobertura.prima_adquisicion).toFixed(2));

			let tipoMercancia = this.quote.tipo_mercancia.name;

			if (this.quote.cobertura.is_active_tasa_venta) {

				if (tasaVenta <= primaAdquisicion) {
					this.quote.tasa_prima = 0;
					console.warn("No se ha seleccionado ninguna tasa de venta")
				} else {
					this.quote.tasa_prima = tasaVenta;
				}

			} else if (this.quote.cobertura.is_active_tarifa) {

				if (tarifa <= primaAdquisicion && tipoMercancia != this.enumContenedor.Contenedor) {
					this.quote.tasa_prima = 0;
					console.warn("No se ha seleccionado ninguna tasa de venta")
				} else {
					this.quote.tasa_prima = tarifa;
				}

			} else {

				if (tarifa <= primaAdquisicion) {
					this.quote.tasa_prima = 0;
					console.warn("No se ha seleccionado ninguna tasa de venta")
				} else {
					this.quote.tasa_prima = tarifa;
				}

			}
		} else { // si la tasa de venta ha sido modificada
			let tarifa = Number(this.quote.cobertura.tarifa);
			let primaAdquisicion = Number(Number(this.quote.cobertura.prima_adquisicion).toFixed(2));
			let tasaPrima = Number(this.quote.tasa_prima);
			let referenciaLimite = 0;

			// si no es usuario cliente validar con la tarifa
			if (!this.usuarioCliente) {

				if (tarifa <= primaAdquisicion) {
					referenciaLimite = 0;
				} else {
					referenciaLimite = tarifa;
				}

				if (tasaPrima < referenciaLimite) {
					this.quote.tasa_prima = referenciaLimite;
					alert(`La tasa de venta no puede ser menor a ${String(referenciaLimite)}%`);
				}

			} else {

				// si es usuario cliente validar con la tarifa

				if (tarifa <= primaAdquisicion) {
					referenciaLimite = 0;
				} else {
					referenciaLimite = tarifa;
				}

				if (tasaPrima < referenciaLimite) {
					this.quote.tasa_prima = referenciaLimite;
					alert(`La tasa de venta no puede ser menor a ${String(referenciaLimite)}%`);
				}

			}
		}

		if (this.quote.tasa_prima >= 1) {
			this.quote.tasa_prima = 0.99;
			alert("La tasa de venta no puede ser mayor a 0.99");
		}

		tasa_prima = this.quote.tasa_prima / 100;

		this.quote.prima = (parseFloat(String(this.quote.total_asegurado).replace(/,/g, "")) * parseFloat(tasa_prima)).toFixed(2);

		this.quote.prima_contenedor = this.quote.prima_contenedor ? this.quote.prima_contenedor : 0;
		this.quote.prima_contenedor = parseFloat(this.quote.prima_contenedor).toFixed(2);

		if (this.quote.rc_errores_omisiones) {
			if (parseInt(String(this.quote.valor_mercancia).replace(/,/g, "")) <= 10000) {
				this.quote.prima_eo = 10;
			} else if (parseInt(String(this.quote.valor_mercancia).replace(/,/g, "")) > 10000 && parseInt(String(this.quote.valor_mercancia).replace(/,/g, "")) <= 50000) {
				this.quote.prima_eo = 25;
			} else if (parseInt(String(this.quote.valor_mercancia).replace(/,/g, "")) > 50000) {
				this.quote.prima_eo = 35;
			}
		} else {
			this.quote.prima_eo = 0;
		}

		if (this.quote.currency_total == 'usd') {
			this.quote.prima_eo = (parseFloat(this.quote.prima_eo)).toFixed(2);
		} else {
			this.quote.prima_eo = (this.quote.prima_eo * this.rate_exchange_usd).toFixed(2);
		}

		this.quote.total_prima = (parseFloat(this.quote.prima) + parseFloat(this.quote.prima_eo) + parseFloat(this.quote.prima_contenedor)).toFixed(2);

		if(this.quote.compania.name == 'JAH' && parseFloat(this.quote.total_prima) < 65){
			if(this.quote.tipo_mercancia.id == 50){
				this.quote.total_prima = 65;
				this.prima_minima = true;
			}
			else{
				if(parseFloat(this.quote.total_prima) < 60){
					this.quote.total_prima = 60;
					this.prima_minima = true;
				}
				else{
					this.prima_minima = false;
				}
			}
		}else if(this.quote.cobertura.is_active){
			let total_prima, prima_minima;
			if(this.quote.currency_total.toUpperCase() == this.quote.cobertura.moneda){
				total_prima = parseFloat(this.quote.total_prima);
				prima_minima = parseFloat(this.quote.cobertura.prima_minima);
			}else{
				total_prima = parseFloat(this.quote.total_prima);
				prima_minima = this.changeCurrency(this.quote.cobertura.moneda,this.quote.currency_total,parseFloat(this.quote.cobertura.prima_minima));
			}
			if(total_prima<prima_minima){
				this.quote.total_prima = parseFloat(this.quote.cobertura.prima_minima);
				this.prima_minima = true;
			}else {
				this.prima_minima = false;
			}
		}else{
			this.prima_minima = false;
		}

		this.quote.result_gran_total_peso = this.quote.total_prima / this.rate_exchange_usd;
		this.quote.result_gran_total_peso = parseFloat(this.quote.result_gran_total_peso).toFixed(2);
		this.quote.result_gran_total_dollar = this.quote.total_prima * this.rate_exchange_usd;
		this.quote.result_gran_total_dollar = parseFloat(this.quote.result_gran_total_dollar).toFixed(2);

		this.onAmountChange('prima', { 'data': this.quote.prima }, null);
		this.onAmountChange('total_prima', { 'data': this.quote.total_prima }, null);
		this.onAmountChange('result_gran_total_peso', { 'data': this.quote.result_gran_total_peso }, null);
		this.onAmountChange('result_gran_total_dollar', { 'data': this.quote.result_gran_total_dollar }, null);
		this.agregarPorcentaje(); //agregar porcentaje
	};

	changeStatus(param) {

		let data = {
			url: this.load_selected.url,
			params: {
				status: param
			}
		};

		this.saveStatus.emit(data);
	};

	start;
	actual_page;
	end;
	not_next;
	show_prev_block;
	status_quote;
	not_prev;

	previousBlockPages(params) {
		if (params) {
			if (this.start < this.actual_page) {
				this.start = this.start - 1;
				this.end = this.end - 1;
			}
		} else {
			this.start = this.start - 5;
			this.end = this.end - 5;

			if (this.end < this.totalPages.length) {
				this.not_next = false;
			}
		}

		if (this.end <= 5) {
			this.start = 0;
			this.end = 5;
			this.show_prev_block = false;
		}
	};

	selectPage(parPage) {

		if (this._pag_config.next || this._pag_config.previous) {

			if (this._pag_config.next) {

				var url = this._pag_config.next.substring(0, this._pag_config.next.indexOf("?page=") + 6);

				url += parPage.toString();
			} else {
				if (this._pag_config.previous.indexOf('?page=') !== -1) {
					var url = this._pag_config.previous.substring(0, this._pag_config.previous.indexOf("?page=") + 6);
					url += parPage.toString();

				} else {
					var url = this._pag_config.previous
				}
			}
		}

		if (this.status_quote) {
			url += ('&status=' + this.status_quote);
		}

		console.log('url', url);
		// emit
		this.getContractors.emit(String(url));


		this.actual_page = parPage;
		if (this.actual_page > 1) {
			this.not_prev = false;
		}

		if (this.actual_page == this.totalPages.length - 1) {
			this.not_next = true;
		}
	};

	nextBlockPages(params) {
		this.show_prev_block = true;

		if (params) {
			if (this.end > this.actual_page) {
				this.start = this.start + 1;
				this.end = this.end + 1;
			}
		} else {
			if (this.end < this.totalPages.length) {
				this.start = this.start + 5;
				this.end = this.end + 5;

				if (this.end == this.totalPages.length) {
					this.not_next = true;
				}
			} else {
				this.not_next = true;
			}
		}
	};

	// form: FormGroup;

	// create(parType, parTitle, parContent) {

	// 	const temp = this.form.getRawValue();
	// 	const title = parTitle;
	// 	const content = parContent;
	// 	const type = parType;
	// };

	certificate;

	pdf() {

		this.sendPdfData.emit(this.certificate);
	}

	/**
	 * Verifica si el total asegurado es menor o igual al limite de despacho
	 * (si el limite de despacho es 0 siempre retorna true)
	 * @returns {boolean} true si el total asegurado es menor o igual al limite de despacho y false si es mayor
	 */
	verificarLimiteDespacho(): boolean {
		let limiteDespacho = this.limite_despacho ? this.limite_despacho : 0;
		let totalAsegurado = parseFloat(String(this.quote.total_asegurado).replace(/,/g, ''));

		if (limiteDespacho === 0) {
			return true;
		}

		return totalAsegurado <= limiteDespacho;
	}

	validarFechaInicio() {
		let fechaInicio = this.quote.importacion_desde;
		this.fechaInicioValido = true;

		if (fechaInicio === null) {
			this.fechaInicioValido = false;
			return;
		}

		if (fechaInicio.toString() === 'Invalid Date') {
			this.fechaInicioValido = false;
			return;
		}

		fechaInicio.setHours(0, 0, 0, 0);
		if (fechaInicio.toString() === new Date('12/31/1969').toString()) {
			this.fechaInicioValido = false;
			return;
		}
		return true;
	}

	validarFechaFin() {
		let fechaFin = this.quote.importacion_hasta;
		this.fechaFinValido = true;

		if (fechaFin === null) {
			this.fechaFinValido = false;
			return;
		}

		if (fechaFin.toString() === 'Invalid Date') {
			this.fechaFinValido = false;
			return;
		}

		fechaFin.setHours(0, 0, 0, 0);
		if (fechaFin.toString() === new Date('12/31/1969').toString()) {
			this.fechaFinValido = false;
			return;
		}
		return true;
	}

	verificarValorMercancia() {
		let valorMercancia = parseFloat(this.quote.valor_mercancia);

		if (valorMercancia <= 0) {
			return false;
		}

		if (isNaN(valorMercancia)) {
			return false;
		}

		return true;
	}

	tasaVentaValido() {
		let primaAdquisicion = 0;
		let tasaPrima = 0;

		if (this.quote.cobertura.prima_adquisicion.indexOf('%') !== -1) {
			primaAdquisicion = Number(this.quote.cobertura.prima_adquisicion.replace('%', '').toFixed(2));
		} else {
			primaAdquisicion = Number(Number(this.quote.cobertura.prima_adquisicion).toFixed(2));
		}

		if (this.quote.tasa_prima.indexOf('%') !== -1) {
			tasaPrima = Number(this.quote.tasa_prima.replace('%', ''));
		} else {
			tasaPrima = Number(this.quote.tasa_prima);
		}

		if (tasaPrima <= primaAdquisicion) {
			return false;
		}
		return true;
	}

	sendCertificate() {
		// CONTENEDORES cambiar pies por pulgadas
		for (let i in this.containers) {
			let item = (this.containers[i].type).replace('PIES', 'PULGADAS');
			this.containers[i].type = item;
		}

		if (!this.admin) {
			let cliente = JSON.parse(localStorage.client_group);
			this.cliente_seleccionado = cliente;
		}

		// validar gastos adicionales
		let gastos_adicionales_ = '0';

		let tipoMercancia = this.quote.tipo_mercancia.name; // tipo de mercancia para contenedores

		if (tipoMercancia == this.enumContenedor.Contenedor) {
			// si es contenedor validar si la tasa venta es 0.1 y si es así convertir a 10
			if (typeof this.quote.tasa_prima === 'string' && this.quote.tasa_prima.indexOf('%') !== -1) {
				if (this.quote.tasa_prima == '0.1%') {
					this.quote.tasa_prima = '10%';
				}
			} else if (this.quote.tasa_prima == 0.1) {
				this.quote.tasa_prima = 10;
			}
		} else {
			// si no es contenedor hacer la validacion normal
			if (!this.tasaVentaValido()){
				this.alertaError('Tasa de venta', 'La tasa de venta no es válida');
				return;
			}
		}

		if (!this.verificarValorMercancia()) {
			this.alertaError('Valor y Tarifa', 'El valor de la mercancía debe ser mayor a 0');
			return;
		}

		if(!this.quote.insured) {
			this.alertaError('Asegurado', 'Por favor elige un asegurado');
			return;
		}

		if(!this.quote.compania) {
			this.alertaError('Generales', 'Por favor elige una aseguradora');
			return;
		}

		if(!this.quote.cobertura) {
			this.alertaError('Generales', 'Por favor elige una cobertura');
			return;
		}

		if(!this.quote.origen_pais || !this.quote.destino_pais) {
			this.alertaError('Generales', 'Por favor ingresa el país de origen y destino');
			return;
		}

		if(!this.quote.origen_ciudad || !this.quote.destino_ciudad) {
			this.alertaError('Generales', 'Por favor ingresa la ciudad de origen y destino');
			return;
		}

		if (this.validarFechaInicio() === undefined) {
			this.alertaError('Fecha inicio', 'Fecha inválida, por favor ingresa una fecha correcta');
			return;
		}

		if (this.validarFechaFin() === undefined) {
			this.alertaError('Fecha fin', 'Fecha inválida, por favor ingresa una fecha correcta');
			return;
		}

		if (!this.verificarLimiteDespacho()) {
			this.alertaError('Total asegurado', 'El total asegurado no puede ser mayor al límite del despacho');
			return;
		}

		if (this.quote.compania.name == 'JAH') {
			if(gastos_adicionales_ && this.gas_add !== '0') {
				// gastos_adicionales_ = (parseFloat(String(this.quote.valor_mercancia).replace(/,/g, "")) * 0.1).toFixed(2);
				gastos_adicionales_ = String(this.gastos_adicionales.toFixed(2));
			} else {
				gastos_adicionales_ = '0';
			}
		}

		let gastos_operacion = '0';
		if(this.quote.operacion || this.quote.operacion > 0) {

			gastos_operacion = ((this.quote.operacion).replace(/,/, ''));
		}

		let gran_total_prima = '0';
		let _prima = '0';
		if(this.quote.total_prima){
			gran_total_prima = (this.quote.total_prima).replace(/,/, '');
			_prima = (this.quote.prima).replace(/,/, '');
		}

		let journey_coverage = '';
		let journey_type;

		let transport_value;

		if(this.quote.trayecto){
			// switch (this.quote.trayecto.name) {
			// 	case 'Door to door':
			// 		journey_coverage = 'Door to Door'
			// 		break;
			// 	case 'Port to port':
			// 		journey_coverage = 'Port to Port'
			// 		break;
			// 	case 'Port to door':
			// 		journey_coverage = 'Port to Door'
			// 		break;
			// 	case 'Door to port':
			// 		journey_coverage = 'Door to Port'
			// 		break;

			// 	default:
			// 		journey_coverage = 'Port to Door'
			// 		break;
			// }
			
			// modificacion para agregar los trayectos de airport
			// establecer las palabras con primera letra en mayuscula excepto la union; ejemplo: (Door to door -> Door to Door)
			let trayecto = this.quote.trayecto.name;
			trayecto = trayecto.replace(/(^\w{1})|(\s+\w{1})/g, (letter: string) => letter.toUpperCase());
			trayecto = trayecto.replace('To', 'to');
			journey_coverage = trayecto;
		}

		journey_type = 4;

		if(this.quote.importacion) {
			journey_type = 1;
		} else if(this.quote.exportacion) {
			journey_type = 2;
		} else if(this.quote.transporte_nacional) {
			journey_type = 3;
		}

		// si es JAH y es Multimodal
		if(this.quote.compania.name == 'JAH') {

			// Si es multimodal
			if(this.quote.transporte.value == 7){
				transport_value = this.jah_transport_type;
			} else if(this.quote.transporte.value == 4) {
				if(this.quote.transporte_nacional) {
					// code...
					transport_value = {value: 3, name: 'Terrestre Nacional'};
				} else {
					transport_value = {value: 4, name: 'Terrestre Internacional'};
				}
			} else {
				transport_value = this.quote.transporte;
			}

		} else {
			transport_value = this.quote.transporte;
		}

		(['HDI', 'CHUBB GLOBAL', 'CHUBB INTERNACIONAL'].includes(this.quote.compania.name)) ? this.establecerTipoMonedaHDI() : '';
		// this.quote.compania.name === 'HDI' || this.quote.compania.name === 'CHUBB GLOBAL' ? this.establecerTipoMonedaHDI() : '';

		this.certificate = {
			'contratante': this.cliente_seleccionado.id,
			'asegurado': parseInt(this.quote.insured.id),
			'compania': this.quote.compania,
			'numero_contenedor': '',
			'numero_pedimento_referencia': this.quote.numero_pedimento_referencia,
			'numero_sello': this.quote.numero_sello ? this.quote.numero_sello : ' ',
			'tipo_mercancia_option': this.quote.tipo_mercancia.name,
			'prima_venta': this.quote.cobertura ? parseFloat(this.quote.cobertura.tarifa) : null,
			'descripcion_mercancia': this.quote.descripcion_mercancia ? this.quote.descripcion_mercancia : '-',
			'linea_transportista': this.quote.compania_transportadora,
			'numero_documento_contenedor': this.quote.documento,
			'buque_viaje_contenedor': this.quote.buque,
			'do_contenedor': 0,
			'operador': this.quote.operador ? this.quote.operador : 'Esscalo',
			'tipo_embalaje': this.quote.tipo_embalaje ? this.quote.tipo_embalaje : 1,
			'tipo_embalaje_another_option': this.quote.tipo_embalaje_otro ? this.quote.tipo_embalaje_otro : '',
			'tipo_empaque': this.quote.tipo_empaque,
			'medidas_seguridad': this.quote.medidas_seguridad,
			'transporte_nacional': this.quote.transporte_nacional,
			'importacion': this.quote.importacion,
			'exportacion': this.quote.exportacion,
			// 'fecha_inicio': new Date(this.quote.importacion_desde),
			'fecha_inicio': new Date(this.quote.importacion_desde.getFullYear(), this.quote.importacion_desde.getMonth(),this.quote.importacion_desde.getDate()),
			//'fecha_fin': new Date(this.quote.importacion_hasta),
			'fecha_fin': new Date(this.quote.importacion_hasta.getFullYear(), this.quote.importacion_hasta.getMonth(),this.quote.importacion_hasta.getDate()),
			// 'cobertura_door_to_door': this.quote.trayecto == 1 ? 'Door to Door' : this.quote.trayecto == 2 ? 'Door to Port' : this.quote.trayecto == 3 ? 'Port to Port' : 'Port to Door',
			'cobertura_door_to_door': journey_coverage,
			'tipo_cambio_mxn': parseFloat((this.rate_exchange_mxn).toFixed(2)),
			'tipo_cambio_usd': parseFloat((this.rate_exchange_usd).toFixed(2)),
			'tipo_cambio_eur': parseFloat((this.rate_exchange_eur).toFixed(2)),
			'tipo_de_trayecto'  : journey_type,
			'valor_mercancia': this.quote.valor_mercancia ? parseFloat(String(this.quote.valor_mercancia).replace(/,/g, "")) : 0,
			'valor_mercancia_exchange': this.quote.valor_type == 'mxn' ? 1 : this.quote.valor_type == 'usd' ? 2 : 3,
			'flete': this.quote.flete ? parseFloat(String(this.quote.flete).replace(/,/g, "")) : 0,
			'flete_exchange': this.quote.flete_type == 'mxn' ? 1 : this.quote.flete_type == 'usd' ? 2 : 3,
			'impuestos_nacionales': this.quote.impuestos_nacionales ? parseFloat(String(this.quote.impuestos_nacionales).replace(/,/g, "")) : 0,
			'impuestos_nacionales_exchange': this.quote.impuestos_type == 'mxn' ? 1 : this.quote.impuestos_type == 'usd' ? 2 : 3,
			'lucro_cesante': this.quote.lucro_cesante ? parseFloat(String(this.quote.lucro_cesante).replace(/,/g, "")) : 0,
			'subtotal': parseFloat(String(this.quote.subtotal).replace(/,/g, "")),
			'gastos_operacionales': gastos_operacion ? parseFloat(gastos_operacion) : 0,
			'gastos_operacionales_exchange': this.quote.operacion_type == 'mxn' ? 1 : this.quote.operacion_type == 'usd' ? 2 : 3,
			// 'gastos_adicionales': (parseFloat(String(this.quote.valor_mercancia).replace( /,/g, "")) * 0.1).toFixed(2),
			'gastos_adicionales': this.quote.gastos_adicionales == true ? 1 : 0,
			'total': parseFloat(String(this.quote.total_asegurado).replace(/,/g, "")),
			'total_exchange': this.quote.currency_total == 'mxn' ? 1 : 2,
			'cobertura_contenedor': this.quote.cobertura_contenedor,
			'rc_errores_omisiones': this.quote.rc_errores_omisiones,
			'tasa': this.quote.tasa_prima ? parseFloat(this.quote.tasa_prima) : 0,
			'tarifa_quote': this.quote.cobertura ? parseFloat(this.quote.cobertura.tarifa) : 0,
			'prima': parseFloat(_prima),
			'primaEO': this.quote.prima_eo ? parseFloat(this.quote.prima_eo) : 0,
			'primaeo': parseFloat(this.quote.prima_eo),
			'prima_contenedor': this.quote.prima_contenedor ? parseFloat(this.quote.prima_contenedor) : 0,
			'gran_total': gran_total_prima ? parseFloat(gran_total_prima) : 0,
			'prima_check': this.quote.prima_check,
			'primaEO_check': this.quote.prima_eo_check,
			'primaeo_check': this.quote.prima_eo_check,
			'prima_contenedor_check': this.quote.prima_contenedor_check,
			'total_check': this.quote.total_check,
			'observaciones': this.quote.observaciones ? this.quote.observaciones : '​',
			'desde': {
				'country': this.quote.origen_pais ? this.quote.origen_pais.name : null,
				'id': this.quote.origen_pais ? this.quote.origen_pais.country : null,
				'city': this.quote.origen_ciudad,
				'address': null
				// actualizacion a direccion simplificada
				// 'address': this.quote.origen_calle + " " + this.quote.origen_numero + ", " + this.quote.origen_colonia + ", " + this.quote.origen_codigo_postal,
				// 'details': {
				// 	'street':this.quote.origen_calle,
				// 	'number':this.quote.origen_numero,
				// 	'colony': this.quote.origen_colonia,
				// 	'zipcode':this.quote.origen_codigo_postal
				// }
			},
			'hasta': {
				'country': this.quote.destino_pais ? this.quote.destino_pais.name : null,
				'id': this.quote.destino_pais ? this.quote.destino_pais.country : null,
				'city': this.quote.destino_ciudad,
				'address': null
				// actualizacion a direccion simplificada
				// 'address': this.quote.destino_calle + " " + this.quote.destino_numero + ", " + this.quote.destino_colonia + ", " + this.quote.destino_codigo_postal,
				// 'details': {
				// 	'street':this.quote.destino_calle,
				// 	'number':this.quote.destino_numero,
				// 	'colony': this.quote.destino_colonia,
				// 	'zipcode':this.quote.destino_codigo_postal
				// }
			},
			'tipo_mercancia': {
				"id": this.quote.tipo_mercancia.id,
				"product": this.quote.tipo_mercancia.product ? this.quote.tipo_mercancia.product : 0,
				"name": this.quote.tipo_mercancia.name,
				"quotation": this.quote.tipo_mercancia.quotation ? this.quote.tipo_mercancia.quotation : 0
			},
			'tipo_contenedor': {},
			'contenedores': this.containers,
			'rate': {
				'transport': transport_value ? transport_value.value : null,
				'name': transport_value ? transport_value.name : null,
				'value': true,
				'cover': this.quote.cobertura.cover ? this.quote.cobertura.cover : 0,
				'deductible': this.quote.cobertura ? this.quote.cobertura.deductible : "10% SOBRE EL VALOR DE LA PERDIDA"
			},
			'cargaquotefile_cargaquote':[]
		};

		// this.certificate_ = certificate;
		// console.log(this.certificate);

		this.cargaQuotes.emit(this.certificate);
		this.setFechasValidas();
		// this.restablecerBanderasInputs();
		// this.next_of_product(6);
	};

	sendCertificateDocumental() {
		// CONTENEDORES cambiar pies por pulgadas
		for (let i in this.containers) {
			let item = (this.containers[i].type).replace('PIES', 'PULGADAS');
			this.containers[i].type = item;
		}

		if (!this.admin) {
			let cliente = JSON.parse(localStorage.client_group);
			this.cliente_seleccionado = cliente;
		}

		// validar gastos adicionales
		let gastos_adicionales_ = '0';

		if (!this.tasaVentaValido()){
			this.alertaError('Tasa de venta', 'La tasa de venta no es válida');
			return;
		}

		if (!this.verificarValorMercancia()) {
			this.alertaError('Valor y Tarifa', 'El valor de la mercancía debe ser mayor a 0');
			return;
		}

		if(!this.quote.insured && this.metodo_quote == 'Documental') {
			this.alertaError('Asegurado', 'Por favor elige un asegurado');
			return;
		}

		if(this.validate_documents()) {
			this.alertaError('Documento', 'Por favor ingresa un nombre para el documento');
			return;
		}

		if(!this.quote.compania) {
			this.alertaError('Generales', 'Por favor elige una aseguradora');
			return;
		}

		if(!this.quote.cobertura && this.metodo_quote != 'Documental') {
			this.alertaError('Generales', 'Por favor elige una cobertura');
			return;
		}

		if(!this.quote.origen_pais || !this.quote.destino_pais) {
			this.alertaError('Generales', 'Por favor ingresa el país de origen y destino');
			return;
		}

		if(!this.quote.origen_ciudad || !this.quote.destino_ciudad) {
			this.alertaError('Generales', 'Por favor ingresa la ciudad de origen y destino');
			return;
		}

		if (this.validarFechaInicio() === undefined) {
			this.alertaError('Fecha inicio', 'Fecha inválida, por favor ingresa una fecha correcta');
			return;
		}

		if (this.validarFechaFin() === undefined) {
			this.alertaError('Fecha fin', 'Fecha inválida, por favor ingresa una fecha correcta');
			return;
		}

		if (!this.verificarLimiteDespacho()) {
			this.alertaError('Total asegurado', 'El total asegurado no puede ser mayor al límite del despacho');
			return;
		}

		let gastos_operacion = '0';
		if(this.quote.operacion || this.quote.operacion > 0) {

			gastos_operacion = ((this.quote.operacion).replace(/,/, ''));
		}

		let gran_total_prima = '0';
		let _prima = '0';
		if(this.quote.total_prima){
			gran_total_prima = (this.quote.total_prima).replace(/,/, '');
			_prima = (this.quote.prima).replace(/,/, '');
		}
		if (this.file_selected){
	      this.quote.document_file = this.file_selected;
	    }else{
	    	this.quote.document_file = []
		}
		let transport_value = this.quote.transporte;

		this.ingresoReferenciasDoc();

		(['HDI', 'CHUBB GLOBAL', 'CHUBB INTERNACIONAL'].includes(this.quote.compania.name)) ? this.establecerTipoMonedaHDI() : '';
		// this.quote.compania.name === 'HDI' || this.quote.compania.name === 'CHUBB GLOBAL' ? this.establecerTipoMonedaHDI() : '';

		// console.log("envio.- this.quote.documents",this.quote.documents)
		this.certificate = {
			'contratante': this.cliente_seleccionado.id,
			'asegurado': parseInt(this.quote.insured.id),
			'compania': this.quote.compania,
			'numero_contenedor': '',
			'numero_pedimento_referencia': this.quote.numero_pedimento_referencia,
			'numero_sello': this.quote.numero_sello,
			'tipo_mercancia_option': null,
			'prima_venta': this.quote.cobertura ? parseFloat(this.quote.cobertura.tarifa) : null,
			'descripcion_mercancia': this.quote.descripcion_mercancia ? this.quote.descripcion_mercancia : '',
			'linea_transportista': null,
			'numero_documento_contenedor': null,
			'buque_viaje_contenedor': null,
			'do_contenedor':null,
			'operador': null,
			'tipo_embalaje': 0,
			'tipo_embalaje_another_option': null,
			'tipo_empaque': null,
			'medidas_seguridad': null,
			'transporte_nacional': null,
			'importacion': null,
			'exportacion': null,
			// 'fecha_inicio': new Date(this.quote.importacion_desde),
			'fecha_inicio': new Date(this.quote.importacion_desde.getFullYear(), this.quote.importacion_desde.getMonth(),this.quote.importacion_desde.getDate()),
			//'fecha_fin': new Date(this.quote.importacion_hasta),
			'fecha_fin': new Date(this.quote.importacion_hasta.getFullYear(), this.quote.importacion_hasta.getMonth(),this.quote.importacion_hasta.getDate()),
			'cobertura_door_to_door': null,
			'tipo_cambio_mxn': parseFloat((this.rate_exchange_mxn).toFixed(2)),
			'tipo_cambio_usd': parseFloat((this.rate_exchange_usd).toFixed(2)),
			'tipo_cambio_eur': parseFloat((this.rate_exchange_eur).toFixed(2)),
			'tipo_de_trayecto': 0,
			'valor_mercancia': this.quote.valor_mercancia ? parseFloat(String(this.quote.valor_mercancia).replace(/,/g, "")) : 0,
			'valor_mercancia_exchange': this.quote.valor_type == 'mxn' ? 1 : this.quote.valor_type == 'usd' ? 2 : 3,
			'flete': this.quote.flete ? parseFloat(String(this.quote.flete).replace(/,/g, "")) : 0,
			'flete_exchange': this.quote.flete_type == 'mxn' ? 1 : this.quote.flete_type == 'usd' ? 2 : 3,
			'impuestos_nacionales': this.quote.impuestos_nacionales ? parseFloat(String(this.quote.impuestos_nacionales).replace(/,/g, "")) : 0,
			'impuestos_nacionales_exchange': this.quote.impuestos_type == 'mxn' ? 1 : this.quote.impuestos_type == 'usd' ? 2 : 3,
			'lucro_cesante': this.quote.lucro_cesante ? parseFloat(String(this.quote.lucro_cesante).replace(/,/g, "")) : 0,
			'subtotal': parseFloat(String(this.quote.subtotal).replace(/,/g, "")),
			'gastos_operacionales': gastos_operacion ? parseFloat(gastos_operacion) : 0,
			'gastos_operacionales_exchange': this.quote.operacion_type == 'mxn' ? 1 : this.quote.operacion_type == 'usd' ? 2 : 3,
			// 'gastos_adicionales': (parseFloat(String(this.quote.valor_mercancia).replace( /,/g, "")) * 0.1).toFixed(2),
			'gastos_adicionales': this.quote.gastos_adicionales == true ? 1 : 0,
			'total': parseFloat(String(this.quote.total_asegurado).replace(/,/g, "")),
			'total_exchange': this.quote.currency_total == 'mxn' ? 1 : 2,
			'cobertura_contenedor': this.quote.cobertura_contenedor,
			'rc_errores_omisiones': this.quote.rc_errores_omisiones,
			'tasa': this.quote.tasa_prima ? parseFloat(this.quote.tasa_prima) : 0,
			'tarifa_quote': this.quote.cobertura ? parseFloat(this.quote.cobertura.tarifa) : 0,
			'prima': parseFloat(_prima),
			'primaEO': this.quote.prima_eo ? parseFloat(this.quote.prima_eo) : 0,
			'primaeo': parseFloat(this.quote.prima_eo),
			'prima_contenedor': this.quote.prima_contenedor ? parseFloat(this.quote.prima_contenedor) : 0,
			'gran_total': gran_total_prima ? parseFloat(gran_total_prima) : 0,
			'prima_check': this.quote.prima_check,
			'primaEO_check': this.quote.prima_eo_check,
			'primaeo_check': this.quote.prima_eo_check,
			'prima_contenedor_check': this.quote.prima_contenedor_check,
			'total_check': this.quote.total_check,
			'observaciones': this.quote.observaciones ? this.quote.observaciones : '​',
			'desde': {
				'country': this.quote.origen_pais ? this.quote.origen_pais.name : null,
				'id': this.quote.origen_pais ? this.quote.origen_pais.country : null,
				'city': this.quote.origen_ciudad,
				'address': null
			},
			'hasta': {
				'country': this.quote.destino_pais ? this.quote.destino_pais.name : null,
				'id': this.quote.destino_pais ? this.quote.destino_pais.country : null,
				'city': this.quote.destino_ciudad,
				'address': null
			},
			'tipo_mercancia': {
				"id": this.quote.tipo_mercancia.id,
				"product": this.quote.tipo_mercancia.product ? this.quote.tipo_mercancia.product : 0,
				"name": this.quote.tipo_mercancia.name,
				"quotation": this.quote.tipo_mercancia.quotation ? this.quote.tipo_mercancia.quotation : 0
			},
			'tipo_contenedor': {},
			'contenedores': 0,
			'rate': {
				'transport': transport_value ? transport_value.value : null,
				'name': transport_value ? transport_value.name : null,
				'value': true,
				'cover': this.quote.cobertura.cover ? this.quote.cobertura.cover : 0,
				'deductible': this.quote.cobertura ? this.quote.cobertura.deductible : "10% SOBRE EL VALOR DE LA PERDIDA"
			},
			//'document': this.quote.documento_tipo,
			'quote_type': 2,
			'document_file': this.file_selected,
			'cargaquotefile_cargaquote':this.quote.documents

		};

		this.cargaQuotes.emit(this.certificate);
		this.setFechasValidas();
		// this.restablecerBanderasInputs();

	};


	/**
	 * Ingreso de referencias a certificado
	 */
	ingresoReferenciasDoc() {
		let arregloRef1 = this.quote.documents.map((archivo: any) => archivo.document);
		let referencias1 = arregloRef1.join(', ');

		let arregloRef2 = this.quote.documents.map((archivo: any) => archivo.contenedor);
		let referencias2 = arregloRef2.join(', ');

		this.quote.numero_pedimento_referencia = referencias1;
		this.quote.numero_sello = referencias2;
	}

	alertaError(texto: string, descripcion: string) {
		texto = texto.toLowerCase();
		descripcion = descripcion.charAt(0).toUpperCase() + descripcion.slice(1).toLowerCase();
		swal.fire({
			position: 'top-end',
			html: '<h4 style="color:#F3F3F3">Error en: ' + texto + '</h4>' + '<span style="color:#F3F3F3">' + descripcion + '</span>',
			width: 400,
			padding: '1.5em 0 1em 0',
			background: '#DA5454',
			showConfirmButton: false,
			timer: 3000
		});
	}

	setFechasValidas() {
		this.fechaInicioValido = true;
		this.fechaFinValido = true;
	}

	establecerTipoMonedaHDI() {
		this.quote.valor_type = 'usd';
		this.quote.flete_type = 'usd';
		this.quote.impuestos_type = 'usd';
		this.quote.operacion_type = 'usd';
		this.quote.currency_total = 'usd';
	}

	clear_control(param) {
		if (param == 'tasa_prima') {
		    // console.log(this.quote[param])
		    if (this.quote[param] > 1) {
			    this.quote[param] = '0.';
			}
		} else {
			this.quote[param] = '';
		}
		this.calculateSubtotalUltimate(param);
	}

	set_default(param) {
		if (this.quote[param].replace(/\s/g, "") == '') {
			this.quote[param] = '0';
		}
	}

	emitirCertificateJah(params) {
		if(this.success_certificate_id){
			// this.categories.certificado = false;
			// console.log('compañia', this.quote.compania);

			this.emition_process = true;

			let data = {
				id: this.success_certificate_id,
				// insurance: 'jah'
				insurance : this.quote.compania.name,
				insuranceId : this.quote.compania.id,
				facturacion : params.facturacion
			};

			// aquí dimiss modal
			// $('#modalContact').modal('hide');
			// console.log('data', data);
			//
			this.emitirQuotes.emit(data);
			this.restablecerBanderasInputs();
		}else{
			this.alertaError('Hoja de trabajo', 'Por favor genera la hoja de trabajo primero');
		}
	}

	emitirCertificateHDI(params) {
		if(this.success_certificate_id){
			let data = {
				id: this.success_certificate_id,
				// insurance: 'HDI',
				insurance : this.quote.compania.name,
				params: {
					// service: 'HDI',
					service : this.quote.compania.name,
					carga_quote: this.success_certificate_id,
					email: params.email,
					phone: params.telefono,
					facturacion : params.facturacion
				}
			};

			// console.log('------------->', params);

			// console.log('data', data);

			this.emitirQuotes.emit(data);
			this.restablecerBanderasInputs();
		}else{
			this.alertaError('Hoja de trabajo', 'Por favor genera la hoja de trabajo primero');
		}

	}

	/**
	 * Restablece las banderas de los inputs de la tasa de venta
	 * y los paises de origen y destino
	 */
	private restablecerBanderasInputs() {
		this.tasa_venta_modificada = false;
		this.pais_origen_modificado = false;
		this.pais_destino_modificado = false;

		// restablecer inputs de la ciudad de origen y destino
		this.quote.origen_ciudad = '';
		this.quote.destino_ciudad = '';

		// restablecer inputs de fecha de inicio y fin
		this.quote.importacion_desde = '';
		this.quote.importacion_hasta = '';
	}

	// Formatos y funcioens
	addDays(date, days) {

		date.setDate(date.getDate() + days);
		return date;

	}

	// onFileChange(event) {
	//     const formData: FormData = new FormData();
	//     formData.append('document_file', event.target.files[0], event.target.files[0].name);
	//     this.file_selected = formData;
	// }
	onFileChange(event, index, document) {
		// Validar si los nombres de los document y contenedor están duplicados
		if (this.quote.documents.length > 1){
			for (let i = 0; i < this.quote.documents.length; i++) {
				for (let j = 0; j < this.quote.documents.length; j++) {
					if (i !== j) {
						if (this.quote.documents[i].document === this.quote.documents[j].document) {
							if (this.quote.documents[j].document !== '') {
								this.quote.documents[j].document = this.quote.documents[j].document + ' (' + j + ')';
								document = document + ' (' + j + ')';
							}
						}

						if (this.quote.documents[i].contenedor === this.quote.documents[j].contenedor) {
							if (this.quote.documents[j].contenedor !== '' && this.quote.documents[j].contenedor !== undefined) {
								this.quote.documents[j].contenedor = this.quote.documents[j].contenedor + ' (' + j + ')';
							}
						}
					}
				}
			}
		}

	    if (event.target.files[0].size > 1 && event.target.files[0].size < 6291456 ){ // 6 MB = 6291456 B 3 MB = 3145728
            //console.log("1.- index",index)
            //console.log("1.- this.quote.documents",this.quote.documents)
            //console.log(typeof(event.target.files[0])
            const formData: FormData = new FormData();
            formData.append('document_file', event.target.files[0], event.target.files[0].name);
            this.file_selected[document] =formData;
            //this.quote.document_file = formData
            this.quote.documents[index].filename =  event.target.files[0].name;
            this.quote.documents[index].file =  event.target.files[0];
            //this.load =  true;
            //console.log("2.- this.quote.documents",this.quote.documents)

			if (!this.quote.documents[index].contenedor) {
				this.quote.documents[index].contenedor = '';
			}
		}else{
		    alert('El archivo seleccionado solo pueder pesar un maximo de 6MB');
		}
	}
	onFileChangeCarga(event) {
	    const formData: FormData = new FormData();
	    formData.append('document_file', event.target.files[0], event.target.files[0].name);
		this.quote.document_file = formData
	}

	documentalCotizacor(){
		//for(var i=0; i < this.data_services.length; i++){
		//	if(this.data_services[i].name.indexOf('JAH') != -1){
		//		this.data_services.splice(i, 1);
		//	}
		//}
		this.show_transporte = false;
		this.metodo_quote = 'Documental';
		this.proceso_documental = true;
		this.categories.mercancia = false;
		this.removerContenedorMercancia(); // si se selecciona documental se remueve el contenedor de la lista de mercancias
		this.next_of_product(1);
	}
	changeload(index, document){
		this.quote.documents[index].filename = '';
		delete this.file_selected[document]
	}
	delete_file_row(document){
		this.quote.documents.pop()
		delete this.file_selected[document]
	}

	validate_documents(){
		for(let d in this.quote.documents){
			if (this.quote.documents[d].document == '' || this.quote.documents[d].filename == ''){
				return true;
			}

		}

		if (!this.quote.insured) {
			return true;
		}

		return false;
	}
	getAlertsNews(){
        var total_asegurado = parseFloat((this.quote.total_asegurado).replaceAll(',', ''))
        // Nuevas Alertas
		if(this.quote.compania.name == 'GNP USD'){
		    if (total_asegurado >= 1 && total_asegurado <= 99999.99){
		        alert('GPS Activo + Monitoreo Activo* \n *MA: Monitoreo por empresa de seguridad especializada que aplica los Protocolos Administrativos y Atención de Emergencia por Robo o Accidente');
		    }
		    if (total_asegurado >= 100000){
		        alert('GPS Activo + Monitoreo Activo + Custodia física armada abordo en cabina');
		    }
		} else if(this.quote.compania.name == 'GNP MXN'){
		    if (total_asegurado >= 1 && total_asegurado <= 1999999.99){
		        alert('GPS Activo + Monitoreo Activo* \n *MA: Monitoreo por empresa de seguridad especializada que aplica los Protocolos Administrativos y Atención de Emergencia por Robo o Accidente');
		    }
		    if (total_asegurado >= 2000000){
		        alert('GPS Activo + Monitoreo Activo + Custodia física armada abordo en cabina');
		    }
		} else if(this.quote.compania.name == 'CHUBB USD'){
		    if (total_asegurado >= 1 && total_asegurado <= 99999.99){
		        alert('GPS Activo + Monitoreo Activo* \n *MA: Monitoreo por empresa especializada de seguridad privada que aplica los Protocolos de Operación y Reacción vinculados a las autoridades policiacas.');
		    }
		    if (total_asegurado >= 100000){
		        alert('GPS Activo + Monitoreo Activo + Custodia virtual CV* \n *CV: Custodia Virtual de empresa de seguridad especializada con reporte c/5min.');
		    }
		} else if(this.quote.compania.name == 'CHUBB MXN'){
		    if (total_asegurado >= 1 && total_asegurado <= 1999999.99){
		        alert('GPS Activo + Monitoreo Activo* \n *MA: Monitoreo por empresa especializada de seguridad privada que aplica los Protocolos de Operación y Reacción vinculados a las autoridades policiacas.');
		    }
		    if (total_asegurado >= 2000000){
		        alert('GPS Activo + Monitoreo Activo + Custodia virtual CV* \n *CV: Custodia Virtual de empresa de seguridad especializada con reporte c/5min.');
		    }
		} else if (this.quote.compania.name == 'HDI') {
			// validar con el tipo de mercancia seleccionada (mercancia general, mercancia general especial, electronicos y maquinaria en general)
			let tipoMercancia = this.quote.tipo_mercancia.name; // tipo de mercancia seleccionada (mercancia general, mercancia sensible diversa, mercancia sensible electronicos y maquinaria)
			let transporte = this.quote.transporte.name; // tipo de transporte seleccionado (maritimo, aereo, terrestre)
			let enumTransporte = {
				Terrestre: 'Terrestre',
				Multimodal: 'Multimodal',
			}
			let enumMercanciaHDI = {
				MercanciaGeneral: 'Mercancía general',
				MercanciaSensibleDiversa: 'Mercancía sensible diversa',
				MercanciaSensibleElectronicos: 'Mercancía sensible electrónicos',
				Maquinaria: 'Maquinaria',
			}

			/**
			 * Mercancia general, Mercancía sensible diversa, Mercancía sensible electrónicos y Maquinaria
			 */

			if (transporte == enumTransporte.Terrestre || transporte == enumTransporte.Multimodal) {
				let textoMultimodal = transporte == enumTransporte.Multimodal ? '*Si tu servicio tiene tramo terrestre.\n' : '';
				if (tipoMercancia == enumMercanciaHDI.MercanciaGeneral) {
					if (total_asegurado >= 1 && total_asegurado <= 150000) {
						alert('GPS Activo* \n ' + textoMultimodal + ' *A cargo de una empresa de seguridad especializada de rastreo y monitoreo, la cual cuente con permisos vinculados a la Comisión Nacional de Seguridad, con reportes de telemetría y trazabilidad no mayor a 15 minutos, esta empresa deberá contar con procedimiento o protocolos de operación y reacción vinculados a las autoridades policiacas.');
					}
					if (total_asegurado > 150000 && total_asegurado <= 300000) {
						alert('GPS Activo + Custodia virtual* \n ' + textoMultimodal + ' *A cargo de una empresa de seguridad especializada de rastreo y monitoreo, la cual cuente con permisos vinculados a la Comisión Nacional de Seguridad, con reportes de telemetría y trazabilidad no mayor a 15 minutos, esta empresa deberá contar con procedimiento o protocolos de operación y reacción vinculados a las autoridades policiacas.');
					}
					if (total_asegurado > 300000) {
						alert('GPS Activo + Custodia física* \n ' + textoMultimodal + ' *A cargo de una empresa de seguridad especializada de rastreo y monitoreo, la cual cuente con permisos vinculados a la Comisión Nacional de Seguridad, con reportes de telemetría y trazabilidad no mayor a 15 minutos, esta empresa deberá contar con procedimiento o protocolos de operación y reacción vinculados a las autoridades policiacas.');
					}
				}
				if (tipoMercancia == enumMercanciaHDI.MercanciaSensibleDiversa) { // modificacion de nombre de mercancia
					if (total_asegurado >= 1 && total_asegurado <= 150000) {
						alert('GPS Activo + Custodia virtual* \n ' + textoMultimodal + ' *A cargo de una empresa de seguridad especializada de rastreo y monitoreo, la cual cuente con permisos vinculados a la Comisión Nacional de Seguridad, con reportes de telemetría y trazabilidad no mayor a 15 minutos, esta empresa deberá contar con procedimiento o protocolos de operación y reacción vinculados a las autoridades policiacas.');
					}
					if (total_asegurado > 150000) {
						alert('GPS Activo + Custodia física "armada"* \n ' + textoMultimodal + ' *A cargo de una empresa de seguridad especializada de rastreo y monitoreo, la cual cuente con permisos vinculados a la Comisión Nacional de Seguridad, con reportes de telemetría y trazabilidad no mayor a 15 minutos, esta empresa deberá contar con procedimiento o protocolos de operación y reacción vinculados a las autoridades policiacas.');
					}
				}
				if (tipoMercancia == enumMercanciaHDI.MercanciaSensibleElectronicos) { // modificacion de nombre de mercancia
					if (total_asegurado >= 1) {
						alert('GPS Activo + Custodia física "armada"* \n ' + textoMultimodal + ' *A cargo de una empresa de seguridad especializada de rastreo y monitoreo, la cual cuente con permisos vinculados a la Comisión Nacional de Seguridad, con reportes de telemetría y trazabilidad no mayor a 15 minutos, esta empresa deberá contar con procedimiento o protocolos de operación y reacción vinculados a las autoridades policiacas.');
					}
				}
				if (tipoMercancia == enumMercanciaHDI.Maquinaria) { // modificacion de nombre de mercancia
					if (total_asegurado >= 1 && total_asegurado <= 150000) {
						alert('GPS Activo* \n ' + textoMultimodal + ' *A cargo de una empresa de seguridad especializada de rastreo y monitoreo, la cual cuente con permisos vinculados a la Comisión Nacional de Seguridad, con reportes de telemetría y trazabilidad no mayor a 15 minutos, esta empresa deberá contar con procedimiento o protocolos de operación y reacción vinculados a las autoridades policiacas.');
					}
					if (total_asegurado > 150000) {
						alert('GPS Activo + Custodia virtual* \n ' + textoMultimodal + ' *A cargo de una empresa de seguridad especializada de rastreo y monitoreo, la cual cuente con permisos vinculados a la Comisión Nacional de Seguridad, con reportes de telemetría y trazabilidad no mayor a 15 minutos, esta empresa deberá contar con procedimiento o protocolos de operación y reacción vinculados a las autoridades policiacas.');
					}
				}
			}
		} else if (this.quote.compania.name == 'CHUBB GLOBAL') { // actualizacion chubb global
			// if (total_asegurado >= 1 && total_asegurado <= 99999.99){
		    //     alert('GPS Activo + Monitoreo Activo* \n *MA: Monitoreo por empresa especializada de seguridad privada que aplica los Protocolos de Operación y Reacción vinculados a las autoridades policiacas.');
		    // }
		    if (total_asegurado >= 1){
		        alert('GPS Activo* \n *A cargo de una empresa de seguridad especializada de rastreo y monitoreo, la cual cuente con permisos vinculados a la Comisión Nacional de Seguridad, con reportes de telemetría y trazabilidad no mayor a 15 minutos, esta empresa deberá contar con procedimiento o protocolos de operación y reacción vinculados a las autoridades policiacas.');
		    }
		} else if (this.quote.compania.name == 'CHUBB INTERNACIONAL') { // actualizacion chubb internacional
			if (total_asegurado >= 1) {
				alert('GPS Activo* \n *A cargo de una empresa de seguridad especializada de rastreo y monitoreo, la cual cuente con permisos vinculados a la Comisión Nacional de Seguridad, con reportes de telemetría y trazabilidad no mayor a 15 minutos, esta empresa deberá contar con procedimiento o protocolos de operación y reacción vinculados a las autoridades policiacas.');
			}
		}
		    
	};

	enSeleccionarContenedor(event: any) {
		this.contenedorSelect = event;
		this.quote.descripcion_mercancia = this.contenedorSelect.nombre;

		// procesar el ingreso del valor de la mercancia al cambiar el contenedor
		this.aplicarValorMercancia();
	}

};



// WEBPACK FOOTER //
// ../esscalo_funcionalidad/src/components/escalo/escalo.component.ts